/* eslint-disable */
import React, { Component } from 'react';
import $ from 'jquery';

import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { SketchPicker } from 'react-color'
import reactCSS from 'reactcss'
import { apiUrl,mediaUrl, cmscontentURL} from'../Config/Config';
import { lang } from '../Helpers/lang';
import Select from 'react-select';
import axios from 'axios';
import { scrollToTopValidate, PageTitle,scrollToTop } from "../Helpers/SettingHelper";
import Addinputsimple from './Addinputsimple';
import { CKEditor, CKEditorContext } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import queryString from "query-string";
import { ShadowPicker } from "react-shadow-picker";

class Setting extends Component {
	
	constructor(props)
	{
		super(props);	
		this.state = {
			settings_id:'',
			settings_site_title:'',
			settings_from_name:'',
			settings_admin_email:'',
			settings_from_email:'',
			settings_mailpath:'',
			settings_company_address:'',
			settings_commission_percentage:'',
			settings_smtp_host:'',
			settings_smtp_user:'',
			settings_smtp_pass:'',
			settings_smtp_port:'',
			settings_username:'',
			settings_mobileno:'',
			settings_email_footer:'',
			settings_commision_amount:'',
			smtp_checked:false,
			Loading: false,
			drLoading: false,
			displayColorPicker: false,
			color: {
			r: '241',
			g: '112',
			b: '19',
			a: '1',
			},
			hexColor:'#f17013',
			settings_public_key:'',
			settings_product_key:'',
			settings_secret_key:'',
			stripe_live_checked:false,
			stripe_sandbox_checked:false,
			settings_embedcode:'',
			setting_goal_amount:'',
			settings_access_code:'',
			st_position_left:'',
			st_position_right:'',
			st_position_top:'',
			st_position_bottom:'',
			domainSets:'',
			removeID:[
        	],
			fonttype : [],
			selectedFont:'',
			fontvalue:'',
			st_position_checked:true,
			st_position:'',
			supporter_additional_fee:'',
			product_layout2_checked:true,
			product_layout3_checked:false,
			google_analystic_code:'',
			category_icons_yes:true,
			category_icons_no:false,
			header_cat_limit:1,
			domain_count:'',
			faqmodelcommon:[{"value":"gpt-3.5-turbo","label":"gpt-3.5-turbo"},{"value":"gpt-4-0613","label":"gpt-4-0613"}],
			faqmodelguest: '',
			faqmodeluser: '',
			faqmodelcompany:'',
			faqmodellux:'',
			selectedfaqmodelcommonval:'',
			selectedfaqmodeluserval:'',
			selectedfaqmodelguestval:'',
			selectedfaqmodelcompanyval:'',
			selectedfaqmodelluxval:'',
			selectedfaqmodelcommon:'',
			selectedfaqmodelguest:'',
			selectedfaqmodelcompany:'',
			selectedfaqmodellux:'',
			selectedfaqmodeluserval:'',
			ai_fine_tune_model_id:'',
			aichat_type:"text",
			dashboardView: 'grid',
			tab_icons_yes:'',
			tab_icons_no:'',
			image_preview:'',
			image_name:'',
			image:'',
			st_font_size:'',
			cancellation_fees_type:"flat",
			reschedule_fees_type:"flat",
			reschedule_fee:'',
			reschedule_hr:'',
			aichat_type:"text",
			cancellation_hr:'',
			cancellation_fee:'',
			description : '',
			selectedplugingwidth:"",
			selectedplugingval:'',
			free_video_call_time:"",
			videocall_additional_fee:"",
			extratime_videocall_fee:'',
			showTab:"",
			selectedapptduration:"",
			selecteddurationval:"",

			primary_font:'',
			main_tab_font_size:'',
			menu_font_size:'',
			selectedFontVariant:'',
			st_varient_id: [],
			fontDetails: [],
			shortcut_icons_yes:true,
			shortcut_icons_no:false,
			lineHeight:'',
			selectedallmodelvalue : '',
			finetune_content : '',
			completion_type : '',
			DropdownRadius:'',
			pluginMapRadius:'',
			pluginRadius:'',
			chat_name:'',
			chat_screen_width:"",
			st_aisidebar_icon_width:'',
			st_aisidebar_main_width:'',
			st_aisidebar_collapsed_width:'',

			st_inner_position_top:"",
			st_inner_position_bottom:"",
			st_inner_position_left:"",
			st_inner_position_right:"",
			st_plugin_height:'',
			shadows: {
					pluginShadow:'0px 24px 34px #0404052e',
					pluginInsideLeftShadow: "15px 0 20px -10px #9898983d",
					pluginInsideRightShadow: "-15px 0 20px -10px #9898983d",
					pluginInsideTopShadow: "0 15px 20px -10px #9898983d",
					pluginInsideBottomShadow: "0 -15px 20px -10px #9898983d",
					dashboardShadowGrid:'0 10px 21px 0 #0000001c',
					dashboardShadowList:"0 21px 21px 0 #0000001c",
					sideMenu:"-2px 10px 15px #3434375e",
					largeButton: '0 4px 18px 0 #0404052e',
					// smallButton: '0 18px 21px 0 #000',
					textarea: '0 7px 10px -7px #04040422',
					shortcutMenu: '0px 3px 21px 0px #9f99995c',
					openButton: '0 18px 21px 0 #000',
					shadowAISidebar: "5px 0px 15px 0 #3434372b",
					pluginInset: '5px 0px 15px 0 #3434372b',
					dropdownmenu: '0px 3px 21px 0px #9f99995c',
					shadowListRow: "0px 15px 10px -15px #0404052e",
					shadowTableRow: "0px 15px 10px -15px #0404052e",
					shadowMapPopup:"-2px 10px 15px #3434375e",
					shadowRightSidebar: "0px 15px 10px -15px #0404052e",
					shadowLeftSidebar:"-2px 10px 15px #3434375e",
				},
				


			
		}; 
		

		
		var qs = require('qs');
		var admin_id = localStorage.getItem('admin_id');
		var postobject = {
			admin_id:  admin_id,
			
		};

		
		axios.post(apiUrl+"adminpanel/adminsettings",qs.stringify(postobject)).then(res => {
			if(res.data.results){
				const formpayload = res.data.results;
				const newShadows = {
						pluginShadow:formpayload.plugin_shadow,
						dashboardShadowGrid:formpayload.dashboard_shadow_grid, 
						dashboardShadowList:formpayload.dashboard_shadow_list,
						sideMenu:formpayload.sidemenu_shadow,
						shortcutMenu: formpayload.shortcut_shadow,
						largeButton: formpayload.button_shadow,
						textarea: formpayload.textarea_shadow,
						openButton:formpayload.open_button,
						shadowAISidebar: formpayload.shadow_ai_sidebar,
						dropdownmenu: formpayload.dropdown_menu,
						shadowListRow: formpayload.shadowListRow,
						shadowTableRow: formpayload.shadowTableRow,
						pluginInset: formpayload.pluginInset_shadow,
						shadowMapPopup: formpayload.shadowMapPopup,
						shadowRightSidebar: formpayload.shadowRightSidebar,
						shadowLeftSidebar: formpayload.shadowLeftSidebar,
						pluginInsideLeftShadow: formpayload.pluginInsideLeftShadow,
						pluginInsideRightShadow: formpayload.pluginInsideRightShadow,
						pluginInsideTopShadow: formpayload.pluginInsideTopShadow,
						pluginInsideBottomShadow: formpayload.pluginInsideBottomShadow,
						
				};
				this.setState({shadows: newShadows});
				this.setState({finetune_content:res.data.finetune_content});
				this.setState({st_plugin_height:formpayload.st_plugin_height});

				this.setState({st_aisidebar_icon_width:formpayload.st_aisidebar_icon_width});
				this.setState({st_aisidebar_main_width:formpayload.st_aisidebar_main_width});
				this.setState({st_aisidebar_collapsed_width:formpayload.st_aisidebar_collapsed_width});

				this.setState({st_position: formpayload.st_plugin_position });
					if(formpayload.st_plugin_position =='absolute'){
							$('.d-height').removeClass('d-none');
						}else{
							$('.d-height').addClass('d-none');
					}


					this.setState({st_inner_position_top:formpayload.st_inner_position_top});
					this.setState({st_inner_position_left:formpayload.st_inner_position_left});
				    this.setState({st_inner_position_bottom:formpayload.st_inner_position_bottom});
					 this.setState({st_inner_position_right:formpayload.st_inner_position_right});
				this.setState({pluginRadius:formpayload.pluginRadius});
				this.setState({chat_name:formpayload.chat_name});
				this.setState({chat_screen_width:formpayload.chat_screen_width});
				
				this.setState({DropdownRadius:formpayload.DropdownRadius});
				this.setState({pluginMapRadius:formpayload.pluginMapRadius});
				
				this.setState({completion_type:res.data.completion_type});
				this.setState({settings_id:formpayload.settings_id});
				this.setState({settings_site_title:formpayload.settings_site_title});
				this.setState({settings_from_name:formpayload.settings_from_name});
				this.setState({settings_admin_email:formpayload.settings_admin_email});
				this.setState({settings_from_email:formpayload.settings_from_email});
				this.setState({settings_mailpath:formpayload.settings_mailpath});
				this.setState({settings_company_address:formpayload.settings_company_address});
				this.setState({settings_commission_percentage:formpayload.settings_commission_percentage});
				this.setState({settings_smtp_host:formpayload.settings_smtp_host});
				this.setState({settings_smtp_user:formpayload.settings_smtp_user});
				this.setState({settings_smtp_pass:formpayload.settings_smtp_pass});
				this.setState({settings_smtp_port:formpayload.settings_smtp_port});
				this.setState({settings_username:formpayload.settings_username});
				this.setState({settings_mobileno:formpayload.settings_mobileno});
				this.setState({settings_email_footer:formpayload.settings_email_footer});
				this.setState({hexColor:formpayload.settings_site_background_color});
				this.setState({settings_public_key:formpayload.settings_public_key});
				this.setState({settings_product_key:formpayload.settings_product_key});
				this.setState({setting_goal_amount:formpayload.setting_goal_amount});
				this.setState({supporter_additional_fee:formpayload.supporter_additional_fee});
				this.setState({settings_secret_key:formpayload.settings_secret_key});
				this.setState({settings_embedcode:formpayload.settings_embedcode});
				this.setState({settings_access_code:formpayload.access_code});				
				this.setState({st_position_left:formpayload.st_position_left});
				this.setState({st_position_right:formpayload.st_position_right});
				this.setState({st_position_top:formpayload.st_position_top});
				this.setState({st_position_bottom:formpayload.st_position_bottom});
				this.setState({domainSets : formpayload.domainSets});
				this.setState({settings_commision_amount: formpayload.settings_commision_amount});								
				this.setState({header_cat_limit: formpayload.header_cat_limit});
				this.setState({np_theme: formpayload.notification_popup_theme});
				this.setState({invite_friends_perc: formpayload.invite_friends_perc});
				this.setState({domain_count: formpayload.domain_count})
				this.setState({dashboardView: formpayload.dashboardView})
				this.setState({image_name: formpayload.eta_icon})
				this.setState({st_font_size: formpayload.st_font_size})
				this.setState({showTab: formpayload.showTab})
				this.setState({chat_api_key: formpayload.chat_api_key})
				this.setState({commission_amount: formpayload.commission_amount})
				this.setState({commission_type: formpayload.commission_type})
				this.setState({reschedule_fee: formpayload.reschedule_fee})
				this.setState({reschedule_hr: formpayload.reschedule_hr})
				this.setState({cancellation_fee: formpayload.cancellation_fee})
				this.setState({cancellation_hr: formpayload.cancellation_hr})
				this.setState({lineHeight:formpayload.lineHeight});

				
				this.setState({free_video_call_time: formpayload.free_video_call_time})
				this.setState({videocall_additional_fee: formpayload.videocall_additional_fee})
				this.setState({extratime_videocall_fee: formpayload.extratime_videocall_fee})
			
				this.setState({primary_font:formpayload.primary_font});
				this.setState({main_tab_font_size:formpayload.main_tab_font_size});
				this.setState({menu_font_size:formpayload.menu_font_size});
			

				if(formpayload.settings_faq_common_model_id!== 'null' && formpayload.settings_faq_common_model_id !== ''){
					this.setState({selectedfaqmodelcommon: {value:formpayload.settings_faq_common_model_id, label:formpayload.settings_faq_common_model_id},selectedfaqmodelcommonval:formpayload.settings_faq_common_model_id });
				}
				if(formpayload.pluginwidth!== 'null' && formpayload.pluginwidth !== ''){
					this.setState({selectedplugingwidth: {value:formpayload.pluginwidth, label:formpayload.pluginwidth},selectedplugingval:formpayload.pluginwidth });
				}


				if(formpayload.pluginwidth === '600'){
									
					this.setState({selectedplugingwidth:{value: '600', label: '600px'}});
					this.setState({selectedplugingval:600});
					
				}else if(formpayload.pluginwidth === '700'){ 
					
					this.setState({selectedplugingwidth:{value: '700', label: '700px'}});
					this.setState({selectedplugingval:700});

	
				}else if(formpayload.pluginwidth === '630'){ 
					
					this.setState({selectedplugingwidth:{value: '630', label: '630px'}});
					this.setState({selectedplugingval:630});

	
				}else if(formpayload.pluginwidth === '800'){ 
					
					this.setState({selectedplugingwidth:{value: '800', label: '800px'}});
					this.setState({selectedplugingval:800});

	
				}else if(formpayload.pluginwidth === '900'){ 
					
					this.setState({selectedplugingwidth:{value: '900', label: '900px'}});
					this.setState({selectedplugingval:900});

	
				}else if(formpayload.pluginwidth === '1000'){ 
					
					this.setState({selectedplugingwidth:{value: '1000', label: '1000px'}});
					this.setState({selectedplugingval:1000});

	
				}
			
				if(formpayload.appointment_duration!== 'null' && formpayload.appointment_duration !== ''){
					this.setState({selectedapptduration: {value:formpayload.appointment_duration, label:formpayload.appointment_duration},selecteddurationval:formpayload.appointment_duration });
				}
				
				if(formpayload.settings_faq_user_model_id!== 'null' && formpayload.settings_faq_user_model_id !== ''){
					this.setState({selectedfaqmodeluser: {value:formpayload.settings_faq_user_model_id, label:formpayload.settings_faq_user_model_id},selectedfaqmodeluserval:formpayload.settings_faq_user_model_id });
				}


				if(formpayload.show_shortcut_icons === 'yes'){
					this.setState({shortcut_icons_yes: true });
					this.setState({shortcut_icons_no: false});
				}else{
					this.setState({shortcut_icons_no: true});
					this.setState({shortcut_icons_yes: false });
				}

				if(formpayload.settings_faq_guest_model_id!== 'null' && formpayload.settings_faq_guest_model_id !== ''){
					this.setState({selectedfaqmodelguest: {value:formpayload.settings_faq_guest_model_id, label:formpayload.settings_faq_guest_model_id},selectedfaqmodelguestval:formpayload.settings_faq_guest_model_id});
				}
				if(formpayload.settings_faq_company_model_id!== 'null' && formpayload.settings_faq_company_model_id !== ''){
					this.setState({selectedfaqmodelcompany: {value:formpayload.settings_faq_company_model_id, label:formpayload.settings_faq_company_model_id},selectedfaqmodelcompanyval:formpayload.settings_faq_company_model_id });
				}
				if(formpayload.settings_faq_lux_model_id!== 'null' && formpayload.settings_faq_lux_model_id !== ''){
					this.setState({selectedfaqmodellux: {value:formpayload.settings_faq_lux_model_id, label:formpayload.settings_faq_lux_model_id},selectedfaqmodelluxval:formpayload.settings_faq_lux_model_id });
				}
				this.setState({aichat_type: formpayload.ai_model_type});
				this.setState({ai_fine_tune_model_id: formpayload.ai_fine_tune_model_id});

				if( formpayload.google_analystic_code !== 'null'){
					this.setState({google_analystic_code: formpayload.google_analystic_code});
				}else{
					this.setState({google_analystic_code: ''});
				}
				
				if(formpayload.settings_mail_from_smtp === '1'){
					this.setState({smtp_checked: true});
				}else{
					this.setState({smtp_checked: false});
				}

				if(formpayload.enable_live === '1'){
					this.setState({stripe_live_checked: true,stripe_sandbox_checked:false });
				}else{
					this.setState({stripe_sandbox_checked: true,stripe_live_checked:false});
				}

				

				if(formpayload.product_layout === '2'){
					this.setState({product_layout2_checked: true });
					this.setState({product_layout3_checked: false});
				}else{
					this.setState({product_layout3_checked: true});
					this.setState({product_layout2_checked: false });
				}

				if(formpayload.show_category_icons === 'yes'){
					this.setState({category_icons_yes: true });
					this.setState({category_icons_no: false});
				}else{
					this.setState({category_icons_no: true});
					this.setState({category_icons_yes: false });
				}
				if(formpayload.show_tab_icons === 'yes'){
					this.setState({tab_icons_yes: true });
					this.setState({tab_icons_no: false});
				}else{
					this.setState({tab_icons_no: true});
					this.setState({tab_icons_yes: false });
				}

				if(formpayload.settings_task_model!== 'null' && formpayload.settings_task_model !== ''){
					
					this.setState({selectedallmodel: {value:formpayload.settings_task_model, label:formpayload.settings_task_model},selectedallmodelvalue:formpayload.settings_task_model});
				}
				
				

				if (res.data.fontvarientlist !== '' && res.data.fontvarientlist !== null) {
					const ids = res.data.fontvarientlist.map(item => item.id);
					this.setState({ st_varient_id: ids }); // Set as an array
					this.setselectedvariants(res.data.fontvarientlist);
				}
					if (res.data.setting_font_varients !== '' && res.data.setting_font_varients !== null) {
							this.setState({fontDetails:res.data.setting_font_varients});
					}else{
						this.setState({
							fontDetails: [
								{
								index: Math.random(),
								FontType: "",
								FontSize:'',
								FontWeight:'',
								letterSpacing:'',
								lineHeight:'',
								TopSpace:'',
								BottomSpace:'',
								varient_id : "",
								}
							]
						});
					}
				if(res.data.font!== '' && res.data.font!== null){
					this.setselectedvalue(res.data.font);
				}
			}
		});

		
		axios.get(apiUrl+'font/getfont_name?admin_id='+admin_id)
			
			.then(res => {
				if(res.data.status == 'success'){
				
					this.setState({
						fonttype: res.data.fontlist
					})
				
				}else{
				//console.log("test")
				}
			});
		this.myCallback();
		this.handleInputChange  = this.handleInputChange.bind(this);
		this.onEditorChange = this.onEditorChange.bind( this );
		
    }
	onEditorChange( evt ) {
    	console.log(evt.editor.getData())
    	var callfunc = this;
    	setTimeout(function () {
			callfunc.setState( {
				consent_form_agree: evt.editor.getData()
			});
		},1000);     
    }
	handleCheckBoxChange = (e) => {
		const isChecked = e.target.checked;
		const isCheckedVal = e.target.value;
		console.log(isCheckedVal, '--isChecked')
		if(isChecked){
			this.setState({ st_varient_id: [...this.state.st_varient_id, e.target.value] });
		} else{
			// setSelectedId(selectedIds.filter(id=>id !== checkedId))
			// const index = this.state.st_varient_id.indexOf(e.target.value);
			// this.state.st_varient_id.splice(index,1);
			
			this.setState({ st_varient_id: this.state.st_varient_id.filter(id=>id !== e.target.value) });
			this.setState(prevState => ({
				st_varient_id: prevState.st_varient_id.filter(id => id !== e.target.value) // Ensure `st_varient_id` is an array
			}));
		}
	};
	setselectedvariants(selectvarients=null){
		
	    // const fontVariantArray = selectvarients.map((fontvar, index) => ({
	    //  id: index,
	    //  name: fontvar,
	    // }));
		// Dynamically create select list
		//let fonts = [];	
		selectvarients = (selectvarients != null ? selectvarients : {});
		if (Object.keys(selectvarients).length > 0) {	
		var listings = selectvarients.map((item, index) => {
			//fonts.push({ variant_id: item.name.id, variant_name: item.name.varient_name }),
			return (						
				<div className="form-group" key={index}>
					<input 
					onChange={this.handleCheckBoxChange.bind(this)}
					type="checkbox"  name="st_varients" 
					value={item.id}
					defaultChecked={item.isChecked}
					/>
					<span>{item.varient_name+' '+item.variant_weight}</span>
				</div>									
			);				
		});
		} else{
			var listings = '';
		}
		this.setState({selectedFontVariant : listings})
	}
	handleChangeAimodelcommon = selectedfaqmodelcommon => {
		this.setState({ selectedfaqmodelcommon});
		this.setState({ selectedfaqmodelcommonval : selectedfaqmodelcommon.value });	
		}
   
    handleInputChange(event) {

      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });
      if(name === 'settings_mail_from_smtp'){
      	 this.setState({smtp_checked: !this.state.smtp_checked});
      }	
      if(name === 'settings_enable_live'){
      	 this.setState({stripe_live_checked: !this.state.stripe_live_checked});
      	  this.setState({stripe_sandbox_checked: !this.state.stripe_sandbox_checked});
      }	
      if(name === 'settings_enable_sandbox'){
      	 this.setState({stripe_sandbox_checked: !this.state.stripe_sandbox_checked});
      	 this.setState({stripe_live_checked: !this.state.stripe_live_checked});
      }	
      if(name === 'product_layout'){
      	 this.setState({product_layout2_checked: !this.state.product_layout2_checked});
      	 this.setState({product_layout3_checked: !this.state.product_layout3_checked});
      }

	  if(name === 'category_icons'){
		this.setState({category_icons_yes: !this.state.category_icons_yes});
		this.setState({category_icons_no: !this.state.category_icons_no});
     }

	  if(name === 'drchrono_client_id'){
		this.setState({yourclientid: value});
		this.setState({ dr_refresh_token: '' });

     }
	  
	 if(name === 'show_shortcut'){
		this.setState({shortcut_icons_yes: !this.state.shortcut_icons_yes});
		this.setState({shortcut_icons_no: !this.state.shortcut_icons_no});
     }
	 if (name === 'tab_icons') {
		this.setState({
		  tab_icons_yes: value === 'yes',
		  tab_icons_no: value === 'no'
		});
	 }
	//  if(name === 'cancellation_fees_type_percentage'){
	// 	this.setState({cancellation_fees_type_percentage: !this.state.cancellation_fees_type_percentage});
	// 	this.setState({cancellation_fees_type_flat: !this.state.cancellation_fees_type_flat});
	// }

	// if(name === 'reschedule_fees_type_flat'){
	// 	this.setState({reschedule_fees_type_flat: !this.state.reschedule_fees_type_flat});
	// 	this.setState({reschedule_fees_type_percentage: !this.state.reschedule_fees_type_percentage});
    //  }
	//  if(name === 'reschedule_fees_type_percentage'){
	// 	this.setState({reschedule_fees_type_percentage: !this.state.reschedule_fees_type_percentage});
	// 	this.setState({reschedule_fees_type_flat: !this.state.reschedule_fees_type_flat});
	// }

      if(name === 'st_position'){
      	this.setState({st_position_checked: !this.state.st_position_checked});
      }
    }
	
    componentDidMount() {
		var admin_id =  localStorage.getItem("admin_id");
		axios.get(apiUrl+"adminpanel/getchatmodel?admin_id="+admin_id)
		.then(res => {			
			if(res.data.status == 'success'){
				this.setState({
					faqmodelguest: res.data.faqmodelguest,
					faqmodeluser: res.data.faqmodeluser,
					faqmodelbroker: res.data.faqmodelbroker,
					faqmodellux: res.data.faqmodelrehab,
					faqmodelcompany: res.data.faqmodelcompany,
					all_models: res.data.all_models,

				});		
			}
		});

		const queryParameters = new URLSearchParams(window.location.search)
		const client_id = queryParameters.get("client_id");
		const code = queryParameters.get("code");


      document.title = PageTitle('Settings');
      if(localStorage.getItem('admin_id') === null){
      this.props.history.push('/');
      }
	  let body = document.querySelectorAll("body")[0];
	if(localStorage.getItem('admin_id')){
		body.classList.remove("body-theme");
	}else{
		body.classList.add("body-theme");
	}
     }
	 
	
    handleFormSubmit = () => {
			if(this.validateForm()){
				this.setState({Loading:true});
				
				const config = {
			        headers: {
			          'Content-Type': 'multipart/form-data'
			        }
			      };
				  
				const formPayload = this.state;

				var qs = require('qs');
				if(this.state.smtp_checked === true){
					var settings_mail_from_smtp = '1';
				}else{
					 settings_mail_from_smtp = '0';
				}
				if(this.state.stripe_live_checked === true){
					var settings_enable_live = '1';
				}else{
					 settings_enable_live = '0';
				}

				// if(this.state.st_position_checked === true){
				// 	var plugin_position = 'fixed';
				// }else{
				// 	 plugin_position = 'absolute';
				// }
                
				var fonttype;
				if(formPayload.selectedFont[0]==undefined){
					fonttype = formPayload.selectedFont.value;
				}else{
					fonttype = formPayload.selectedFont[0].value;
				}
				var product_layout = '';
				if(this.state.product_layout3_checked === true){
					 product_layout = '3';
				}else{
					 product_layout = '2';
				}

				var show_category = '';
				if(this.state.category_icons_yes === true){
					show_category = 'yes';
				}else{
					show_category = 'no';
				}
				var show_tab_icons ='';
				
				if(this.state.tab_icons_yes === true){
					show_tab_icons = 'yes';
				}else{
					show_tab_icons = 'no';
				}

						
				// var cancellation_fees_type = '';
				// if(this.state.cancellation_fees_type_flat === true){
				// 	cancellation_fees_type = 'flat';
				// }else{
				// 	cancellation_fees_type = 'percentage';
				// }

				// var reschedule_fees_type = '';
				// if(this.state.reschedule_fees_type_flat === true){
				// 	reschedule_fees_type = 'flat';
				// }else{
				// 	reschedule_fees_type = 'percentage';
				// }

				var show_shortcut = '';
				if(this.state.shortcut_icons_yes === true){
					show_shortcut = 'yes';
				}else{
					show_shortcut = 'no';
				}

				var postObject = {
					settings_id: formPayload.settings_id,
					settings_site_title:formPayload.settings_site_title,
					settings_from_name:formPayload.settings_from_name,
					settings_admin_email:formPayload.settings_admin_email,
					settings_from_email:formPayload.settings_from_email,
					DropdownRadius:formPayload.DropdownRadius,
					pluginMapRadius:formPayload.pluginMapRadius,
					pluginRadius:formPayload.pluginRadius,
					settings_mailpath:formPayload.settings_mailpath,
					settings_company_address:formPayload.settings_company_address,
					settings_commission_percentage:formPayload.settings_commission_percentage,
					site_background: formPayload.hexColor,
					smtp_host:formPayload.settings_smtp_host,
					smtp_user:formPayload.settings_smtp_user,
					smtp_pass:formPayload.settings_smtp_pass,
					smtp_port:formPayload.settings_smtp_port,
					admin_user:formPayload.settings_username,
					admin_no:formPayload.settings_mobileno,
					settings_email_footer:formPayload.settings_email_footer,
					settings_mail_from_smtp:settings_mail_from_smtp,
					settings_public_key:formPayload.settings_public_key,
					settings_product_key:formPayload.settings_product_key,
					setting_goal_amount:formPayload.setting_goal_amount,
					supporter_additional_fee:formPayload.supporter_additional_fee,
					settings_secret_key:formPayload.settings_secret_key,
					settings_enable_live:settings_enable_live,
					st_position_left:formPayload.st_position_left,
					st_position_right:formPayload.st_position_right,
					st_position_top:formPayload.st_position_top,
					st_position_bottom:formPayload.st_position_bottom,
					font 		  : fonttype,
					settings_commision_amount: formPayload.settings_commision_amount,
					
					google_analystic_code: formPayload.google_analystic_code,
					product_layout: product_layout,
					removeId: formPayload.removeID,
					show_category_icons: show_category,
					settings_faq_common_model_id:formPayload.selectedfaqmodelcommonval,
					settings_faq_user_model_id:formPayload.selectedfaqmodeluserval,
					settings_faq_guest_model_id:formPayload.selectedfaqmodelguestval,
					settings_faq_rehab_model_id:formPayload.selectedfaqmodelluxval,
					settings_faq_company_model_id:formPayload.selectedfaqmodelcompanyval,
					aichat_type:formPayload.aichat_type,
					ai_fine_tune_model_id: formPayload.ai_fine_tune_model_id,
					dashboardView: formPayload.dashboardView,
					show_tab_icons:show_tab_icons,
					image: formPayload.image,
					st_font_size: formPayload.st_font_size,
					settings_task_model : formPayload.selectedallmodelvalue,

					cancellation_fee: formPayload.cancellation_fee,
					cancellation_hr: formPayload.cancellation_hr,
					cancellation_fees_type:formPayload.cancellation_fees_type,
					reschedule_fee: formPayload.reschedule_fee,
					reschedule_hr: formPayload.reschedule_hr,
					reschedule_fees_type:formPayload.reschedule_fees_type,
					plugin_width :formPayload.selectedplugingval,
					duration_value :formPayload.selecteddurationval,
					free_video_call_time :formPayload.free_video_call_time,
					videocall_additional_fee :formPayload.videocall_additional_fee,
					extratime_videocall_fee :formPayload.extratime_videocall_fee,
					showTab: formPayload.showTab,
					chat_api_key: formPayload.chat_api_key,
					commission_type : formPayload.commission_type,
					commission_amount : formPayload.commission_amount,
					main_tab_font_size:formPayload.main_tab_font_size,
					menu_font_size:formPayload.menu_font_size,
					primary_font:formPayload.primary_font,
					show_shortcut: show_shortcut,
					st_varient_id:formPayload.st_varient_id,
					fontDetails:JSON.stringify(formPayload.fontDetails),
					chat_name:formPayload.chat_name,
					chat_screen_width:formPayload.chat_screen_width,
					shadow: JSON.stringify(this.state.shadows),

					st_aisidebar_icon_width:formPayload.st_aisidebar_icon_width,
					st_aisidebar_main_width:formPayload.st_aisidebar_main_width,
					st_aisidebar_collapsed_width:formPayload.st_aisidebar_collapsed_width,
					st_inner_position_left:formPayload.st_inner_position_left,
					st_inner_position_bottom:formPayload.st_inner_position_bottom,
					st_inner_position_right:formPayload.st_inner_position_right,
					st_inner_position_top:formPayload.st_inner_position_right,
					st_position: formPayload.st_position,
					
					st_plugin_height:(formPayload.st_plugin_height!='')?formPayload.st_plugin_height:0,
				};
				
				let formData = new FormData();
				for(let k in postObject) {
				formData.append(k, postObject[k]);
				}
			/* 	var domains = formPayload.domainSets
				for(let i in domains){
					formData.append('domainName[]',domains[i]['domain_name'])
				} */
				

				var domains = formPayload.domainSets;

				for(let i in domains){

					if(domains[i]['domain_id'] ==  'undefined'){
						formData.append('domainName['+ i + '][domain_id]','null')		
					}else if(domains[i]['domain_id'] !==  undefined && domains[i]['domain_id'] !==  ''){
						formData.append('domainName['+ i + '][domain_id]',domains[i]['domain_id'])
					}

					formData.append('domainName['+ i + '][domain_name]',domains[i]['domain_name'])
					formData.getAll('domainName');
				}
				axios.post(apiUrl+"adminpanel/settingsave",formData,config).then(res => {
	
					if(res.data.results){
						this.setState({Loading:false});
					        	const formpayload = res.data.results;
								console.log(formPayload,'this is formpayload')
								$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
								this.setState({settings_id:formpayload.settings_id});
								this.setState({settings_site_title:formpayload.settings_site_title});
								this.setState({settings_from_name:formpayload.settings_from_name});
								this.setState({settings_admin_email:formpayload.settings_admin_email});
								this.setState({settings_from_email:formpayload.settings_from_email});
								this.setState({settings_mailpath:formpayload.settings_mailpath});
								this.setState({settings_company_address:formpayload.settings_company_address});
								this.setState({settings_commission_percentage:formpayload.settings_commission_percentage});
								this.setState({settings_smtp_host:formpayload.settings_smtp_host});
								this.setState({settings_smtp_user:formpayload.settings_smtp_user});
								this.setState({settings_smtp_pass:formpayload.settings_smtp_pass});
								this.setState({settings_smtp_port:formpayload.settings_smtp_port});
								this.setState({settings_username:formpayload.settings_username});
								this.setState({settings_mobileno:formpayload.settings_mobileno});
								this.setState({settings_email_footer:formpayload.settings_email_footer});
								this.setState({hexColor:formpayload.settings_site_background_color});
								this.setState({settings_public_key:formpayload.settings_public_key});
								this.setState({settings_product_key:formpayload.settings_product_key});
								this.setState({setting_goal_amount:formpayload.setting_goal_amount});
								this.setState({supporter_additional_fee:formpayload.supporter_additional_fee});
								this.setState({settings_secret_key:formpayload.settings_secret_key});
								this.setState({settings_embedcode:formpayload.settings_embedcode});
								this.setState({settings_access_code:formpayload.access_code});
								this.setState({st_position_left:formpayload.st_position_left});
								this.setState({st_position_right:formpayload.st_position_right});
								this.setState({st_position_top:formpayload.st_position_top});
								this.setState({st_position_bottom:formpayload.st_position_bottom});
								this.setState({domainSets: formpayload.domainSets});
								this.setState({settings_commision_amount: formpayload.settings_commision_amount});
								this.setState({merchant_commision_to_broker: formpayload.merchant_commision_to_broker});	
								this.setState({lux_purchase_count: formpayload.lux_purchase_count});																
								this.setState({header_cat_limit: formpayload.header_cat_limit});
								this.setState({domain_count: formpayload.domain_count});
								this.setState({primary_font:formpayload.primary_font});
								this.setState({main_tab_font_size:formpayload.main_tab_font_size});
								this.setState({menu_font_size:formpayload.menu_font_size});
								
								if(formpayload.settings_faq_common_model_id!== 'null' && formpayload.settings_faq_common_model_id !== ''){
									this.setState({selectedfaqmodelcommon: {value:formpayload.settings_faq_common_model_id, label:formpayload.settings_faq_common_model_id},selectedfaqmodelcommonval:formpayload.settings_faq_common_model_id });
								}
								
								if(formpayload.settings_faq_user_model_id!== 'null' && formpayload.settings_faq_user_model_id !== ''){
									this.setState({selectedfaqmodeluser: {value:formpayload.settings_faq_user_model_id, label:formpayload.settings_faq_user_model_id},selectedfaqmodeluserval:formpayload.settings_faq_user_model_id });
								}
								if(formpayload.settings_faq_guest_model_id!== 'null' && formpayload.settings_faq_guest_model_id !== ''){
									this.setState({selectedfaqmodelguest: {value:formpayload.settings_faq_guest_model_id, label:formpayload.settings_faq_guest_model_id},selectedfaqmodelguestval:formpayload.settings_faq_guest_model_id});
								}
								if(formpayload.settings_faq_company_model_id!== 'null' && formpayload.settings_faq_company_model_id !== ''){
									this.setState({selectedfaqmodelcompany: {value:formpayload.settings_faq_company_model_id, label:formpayload.settings_faq_company_model_id},selectedfaqmodelcompanyval:formpayload.settings_faq_company_model_id });
								}
								if(formpayload.settings_faq_lux_model_id!== 'null' && formpayload.settings_faq_lux_model_id !== ''){
									this.setState({selectedfaqmodellux: {value:formpayload.settings_faq_lux_model_id, label:formpayload.settings_faq_lux_model_id},selectedfaqmodelluxval:formpayload.settings_faq_lux_model_id });
								}
								this.setState({aichat_type: formpayload.ai_model_type});
								this.setState({ai_fine_tune_model_id: formpayload.ai_fine_tune_model_id});


								if( formpayload.google_analystic_code !== 'null'){
									this.setState({google_analystic_code: formpayload.google_analystic_code});
								}else{
									this.setState({google_analystic_code: ''});
								}

								if(formpayload.settings_mail_from_smtp === '1'){
									this.setState({smtp_checked: true});
								}else{
									this.setState({smtp_checked: false});
								}


								

								if(formpayload.product_layout === '2'){
									this.setState({product_layout2_checked: true });
									this.setState({product_layout3_checked: false});
								}else{
									this.setState({product_layout3_checked: true});
									this.setState({product_layout2_checked: false });
								}

								if(formpayload.enable_live === '1'){
									this.setState({stripe_checked: true});
								}else{
									this.setState({stripe_checked: false});
								}

								if(formpayload.show_category_icons === 'yes'){
									this.setState({category_icons_yes: true });
									this.setState({category_icons_no: false});
								}else{
									this.setState({category_icons_no: true});
									this.setState({category_icons_yes: false });
								}
									scrollToTop();

									setTimeout(
										function() {
											$('.success_message').html('');
										}
										.bind(this),
										3000
										);
				    }
						 
				 });
			}
	}

	validateForm() {

		const {settings_commision_amount,settings_id,settings_site_title,settings_from_name,settings_admin_email,settings_from_email,settings_company_address,settings_commission_percentage,settings_smtp_host,settings_smtp_user,settings_smtp_pass,settings_smtp_port,settings_username,settings_mobileno,settings_email_footer,settings_public_key,settings_product_key,setting_goal_amount,supporter_additional_fee,settings_secret_key,settings_embedcode,selectedFont,
			payment_form,domainSets,chat_api_key,DropdownRadius,pluginRadius
		} = this.state;
		const nameRegex = /^[A-Za-z\s.]+$/;
		let errors = 0;
      	//let formIsValid = true;

		  const fontDetails = [...this.state.fontDetails];
		 
  
		  for (let index = 0; index < fontDetails.length; index++) {			
			  if(fontDetails[index].FontType == "") {
				  fontDetails[index].FontTypeCheck = "Type is required";
				errors++;
			  }else{
				  fontDetails[index].FontTypeCheck = "";
				
			  }
		  }
		  this.setState({ fontDetails });
		if (!settings_site_title) { 
			errors++;
			$('.errorsettings_site_title').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_site_title){
			if (!nameRegex.test(settings_site_title)) {
				errors++;
			$('.errorsettings_site_title').html('<span class="errorspan">Please enter the valid site name</span>');
			}else{
				$('.errorsettings_site_title').html('');
			}
			
		}
		if (!domainSets.length>0) { 
			
			errors++;
			$('.errorsettings_domain').html('<span class="errorspan">Please add atleast one domain</span>');
		}else{		
			$('.errorsettings_domain').html('');
		}
		if (!settings_from_name) { 
			errors++;
			$('.errorsettings_from_name').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_from_name){
			if (!nameRegex.test(settings_from_name)) {
				errors++;
			$('.errorsettings_from_name').html('<span class="errorspan">Please enter the valid from name</span>');
			}else{
				$('.errorsettings_from_name').html('');
			}
			
		}

		if (!settings_admin_email) {
			errors++; 
			$('.errorsettings_admin_email').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_admin_email){
			var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
			if (reg.test(settings_admin_email)) 
			{
			  $('.errorsettings_admin_email').html('');
			}else{
			  errors++;
			  
			$('.errorsettings_admin_email').html('<span class="errorspan">Please enter valid email address</span>');
			}
			  
			
			}
		if (!settings_from_email) {
			errors++; 
			$('.errorsettings_from_email').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_from_email){
			var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
			if (reg.test(settings_from_email)) 
			{
			  $('.errorsettings_from_email').html('');
			}else{
			  errors++;
			  
			$('.errorsettings_from_email').html('<span class="errorspan">Please enter valid email address</span>');
			}
			  
			
			}
		if (!DropdownRadius) { 
			errors++;
			$('.errorDropdownRadius').html('<span class="errorspan">Please fill the field</span>');
		}else if(DropdownRadius){		
			$('.errorDropdownRadius').html('');
		}
		if (!pluginRadius) { 
			errors++;
			$('.errorpluginRadius').html('<span class="errorspan">Please fill the field</span>');
		}else if(pluginRadius){		
			$('.errorpluginRadius').html('');
		}

		if (!settings_mobileno) { 
			errors++;
			$('.errorsettings_mobileno').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_mobileno){	
			var pattern = /^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
			var indiapattern =/^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$/;
			   if (pattern.test(settings_mobileno)) {
			   $('.errorsettings_mobileno').html('');
			   }else if(indiapattern.test(settings_mobileno)){
			   $('.errorsettings_mobileno').html('');
			   }else{
					errors++;
			   
					$('.errorsettings_mobileno').html('<span class="errorspan">Please enter valid contact</span>');
				  }
			   }


		

		if (!settings_email_footer) { 
			errors++;
			$('.errorsettings_email_footer').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_company_address){
			$('.errorsettings_email_footer').html('');
		}
		if (!settings_public_key) {
			errors++;
			$('.errorsettings_public_key').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_public_key){
			$('.errorsettings_public_key').html('');
		}
		
		// if (!settings_product_key) {
		// 	errors++;
		// 	$('.errorsettings_product_key').html('<span class="errorspan">Please fill the field</span>');
		// }else if(settings_product_key){
		// 	$('.errorsettings_product_key').html('');
		// }
		
		if (!settings_secret_key) {
			errors++;
			$('.errorsettings_secret_key').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_secret_key){
			$('.errorsettings_secret_key').html('');
		}

		if(!chat_api_key){
			errors++;
			$('.errorsettings_chat_api_key').html('<span class="errorspan">Please fill the API key</span>');
		}else if(chat_api_key){
			$('.errorsettings_chat_api_key').html('');
		}
		

		if(errors>0) {
		setTimeout(function () {
		scrollToTopValidate();
		}, 100);
		return false;
		}
		else {
		return true;
		}
    }

    componentWillReceiveProps(Props){
		

    	  	if(Props.updatesetting !== this.props.updatesetting){ 
			
    		if(Object.keys(Props.updatesetting).length > 0){
				
    			this.setState({ Loading: false });

    			const formpayload = Props.updatesetting[0].results;
				
    			$('.success_message').html('<div class="status_sucess"><h3>'+ Props.updatesetting[0].message+'</h3></div>');
    			this.setState({settings_id:formpayload.settings_id});
    			this.setState({settings_site_title:formpayload.settings_site_title});
    			this.setState({settings_from_name:formpayload.settings_from_name});
    			this.setState({settings_admin_email:formpayload.settings_admin_email});
    			this.setState({settings_from_email:formpayload.settings_from_email});
    			this.setState({settings_mailpath:formpayload.settings_mailpath});
    			this.setState({settings_company_address:formpayload.settings_company_address});
    			this.setState({settings_commission_percentage:formpayload.settings_commission_percentage});
    			this.setState({settings_smtp_host:formpayload.settings_smtp_host});
    			this.setState({settings_smtp_user:formpayload.settings_smtp_user});
    			this.setState({settings_smtp_pass:formpayload.settings_smtp_pass});
    			this.setState({settings_smtp_port:formpayload.settings_smtp_port});
    			this.setState({settings_username:formpayload.settings_username});
    			this.setState({settings_mobileno:formpayload.settings_mobileno});
    			this.setState({settings_email_footer:formpayload.settings_email_footer});
    			this.setState({hexColor:formpayload.settings_site_background_color});
    			this.setState({settings_public_key:formpayload.settings_public_key});
				this.setState({settings_product_key:formpayload.settings_product_key});
				this.setState({setting_goal_amount:formpayload.setting_goal_amount});
				this.setState({supporter_additional_fee:formpayload.supporter_additional_fee});
    			this.setState({settings_secret_key:formpayload.settings_secret_key});
				this.setState({settings_embedcode:formpayload.settings_embedcode});
				this.setState({settings_access_code:formpayload.access_code});
				this.setState({st_position_left:formpayload.st_position_left});
				this.setState({st_position_right:formpayload.st_position_right});
				this.setState({st_position_top:formpayload.st_position_top});
				this.setState({st_position_bottom:formpayload.st_position_bottom});
				this.setState({domainSets: formpayload.domainSets});
				this.setState({DropdownRadius:formpayload.DropdownRadius});
				this.setState({pluginMapRadius:formpayload.pluginMapRadius});

				
    			this.setState({pluginRadius:formpayload.pluginRadius});
				this.setState({chat_name: formpayload.chat_name});
				this.setState({chat_screen_width: formpayload.chat_screen_width});
				
				this.setState({settings_commision_amount: formpayload.settings_commision_amount});
				this.setState({header_cat_limit: formpayload.header_cat_limit});
				this.setState({domain_count: formpayload.domain_count});
				
				
				if( formpayload.google_analystic_code !== 'null'){
					this.setState({google_analystic_code: formpayload.google_analystic_code});
				}else{
					this.setState({google_analystic_code: ''});
				}

    			if(formpayload.settings_mail_from_smtp === '1'){
    				this.setState({smtp_checked: true});
    			}else{
    				this.setState({smtp_checked: false});
    			}


    			if(formpayload.st_plugin_position === 'fixed'){
    				this.setState({st_position_checked: true });
    			}else{
    				this.setState({st_position_checked: false});
    			}

    			if(formpayload.product_layout === '2'){
    				this.setState({product_layout2_checked: true });
    				this.setState({product_layout3_checked: false});
    			}else{
    				this.setState({product_layout3_checked: true});
    				this.setState({product_layout2_checked: false });
    			}

    			if(formpayload.enable_live === '1'){
    				this.setState({stripe_checked: true});
    			}else{
    				this.setState({stripe_checked: false});
    			}

				if(formpayload.show_category_icons === 'yes'){
    				this.setState({category_icons_yes: true });
    				this.setState({category_icons_no: false});
    			}else{
    				this.setState({category_icons_no: true});
    				this.setState({category_icons_yes: false });
    			}
    				scrollToTop();

    				setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
    		}
    	}
    

    	var admin_id = localStorage.getItem('admin_id');
		axios.get(apiUrl+'font/getfont_name?admin_id='+admin_id)
			
			.then(res => {
				if(res.data.status == 'success'){
				
					this.setState({
						fonttype: res.data.fontlist
					})
				
				}else{
				//console.log("test")
				}
			});

	}

	setselectedvalue(selectsers){
		
	    const fontArray = selectsers.map((fonttype, index) => ({
	     id: index,
	     name: fonttype,
	    }));
    // Dynamically create select list
    let fonts = [];
    fontArray.map(item =>
    fonts.push({ label: item.name.label, value: item.name.value }),
    );
    this.setState({selectedFont : fonts})
  }

	handleClick = () => {
	this.setState({ displayColorPicker: !this.state.displayColorPicker })
	};

	handleClose = () => {
	this.setState({ displayColorPicker: false })
	};

	/* handleChange = (color) => {
	this.setState({hexColor : color.hex})
	this.setState({ color: color.rgb })
	}; */

	 copyCodeToClipboard(event){
		event.preventDefault;
		const el = this.textArea
		el.select()
		document.execCommand("copy")
   }


   writeText = () => {
	 
	$('.copied_title').html('<span class=""><h3>Copied</h3></span>');

	//onClick={() =>  navigator.clipboard.writeText(tester)}
	let test1 = this.state.settings_access_code;
	
	let  tester =	'<script src="https://admin.rx.one/plugin.js"></script> <div data-client="'+test1+'"  id="RX_container"></div>';
	 navigator.clipboard.writeText(tester);
	setTimeout(
		function() {
			$('.copied_title').html('');
			$('.copied_title').hide();
		}
		.bind(this),
		3000
		);
		
    }

/*    myCallback = (domainsets) => {
   	//console.log(domainsets,'domainsets')
    this.setState({domainSets: domainsets});
  }; */

  

   myCallback = (domainsets,domainID,domain_count) => {
    this.setState({domainSets: domainsets,removeID: domainID,domain_count:domain_count});
   };
//    handleChangeFont = selectedFont => {
//       this.setState({ selectedFont});
//       this.setState({ fontvalue : selectedFont.value });
//       if(selectedFont.value === ''){
//         //$('.errorfont').html('<span class="errorspan">Please select the font</span>');
//       }else{
//       	 $('.errorfont').html('');
//       }
//    }

   handleChangeAimodeluser = selectedfaqmodeluser => {
	this.setState({ selectedfaqmodeluser});
	this.setState({ selectedfaqmodeluserval : selectedfaqmodeluser.value });	
	}
	handleChangeAimodelguest = selectedfaqmodelguest => {
		this.setState({ selectedfaqmodelguest});
		this.setState({ selectedfaqmodelguestval : selectedfaqmodelguest.value });	
	}
	handleChangePlugingwidth = selectedplugingwidth => {
		this.setState({ selectedplugingwidth});
		this.setState({ selectedplugingval : selectedplugingwidth.value });	
	}
	handleChangeapptduration = selectedapptduration => {
		this.setState({ selectedapptduration});
		this.setState({ selecteddurationval : selectedapptduration.value });	
	}
	
	handleChangeAimodelcompany = selectedfaqmodelcompany => {
		this.setState({ selectedfaqmodelcompany});
		this.setState({ selectedfaqmodelcompanyval : selectedfaqmodelcompany.value });	
	}
	handleChangeAimodellux = selectedfaqmodellux => {
		this.setState({ selectedfaqmodellux});
		this.setState({ selectedfaqmodelluxval : selectedfaqmodellux.value });	
	}
	handleInputddashbordview = (event) => {
        this.setState({ dashboardView: event.target.value });
    };
	onChangeHandler=event=>{
		let reader = new FileReader();
		const file = event.target.files[0];
		const extension = file.name.split('.').pop();
		reader.onloadend = () => {
		  this.setState({
			image_name: file.name,
			image_preview: reader.result,
			image: file,
			fileExtension:extension,
			
		  });
		};
		reader.readAsDataURL(file);
	
		
	  }

	  handleSave = () => {
		this.setState({Loading:true});
		const config = {
			headers: {
			  'Content-Type': 'multipart/form-data'
			}
		  };
		const formPayload = this.state;
		var qs = require('qs');
		var postObject = {
			
			settings_id: formPayload.settings_id,
			admin_id: localStorage.getItem('admin_id'),
			aifeed:this.state.description,
			type : formPayload.type,
			imp_cate : 1
			
		};

		let formData = new FormData();
		for(let k in postObject) {
		formData.append(k, postObject[k]);
		}
	
		
		

		axios.post(apiUrl+"faq/settingaifeedsave",formData,config).then(res => {
			if(res.data.results){
				// this.setState({Loading:false});
				// 		const formpayload = res.data.results;
				// 		$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
				// 		this.setState({settings_id:formpayload.settings_id});
				// 		scrollToTop();
				// 		setTimeout(
				// 			function() {
				// 				$('.success_message').html('');
				// 			}
				// 			.bind(this),
				// 			3000
				// 			);
			}
				 
		 }); 
	
}

handleInputtabview = (event) => {
	this.setState({ showTab: event.target.value });
	
};
handleChangeFont = selectedFont => {
	this.setState({ selectedFont});
	this.setState({ fontvalue : selectedFont.value });
	if(selectedFont.value === ''){
	  //$('.errorfont').html('<span class="errorspan">Please select the font</span>');
	}else{
	  axios.get(apiUrl+'adminpanel/getfont_varient?font_id='+selectedFont.value)
		  .then(res => {
			  if(res.data.status == 'success'){					
				  //if(res.data.fontvarientlist!== '' && res.data.fontvarientlist!== null){
					  this.setselectedvariants(res.data.fontvarientlist);
				  //}
			  
			  }else{
			  //console.log("test")
				  this.setselectedvariants(res.data.fontvarientlist);
			  }
		  });
		 $('.errorfont').html('');
	}
 }
 addFunc = e => {
	this.setState(prevState => ({
	  fontDetails: [
		...prevState.fontDetails,
		{
		  index: Math.random(),
		  FontType: "",
		  FontSize:'',
		  FontWeight:'',
		  letterSpacing:'',
		  lineHeight:'',
		  TopSpace:'',
		  BottomSpace:'',
		  varient_id : "",
		}
	  ]
	}));
};
deleteFunc(record) {
	this.setState({
	  fontDetails: this.state.fontDetails.filter(r => r !== record)
	});
}

addMoreFunc = (e) => {	
	return this.state.fontDetails.map((val, idx) => {
		
		let FontType = `FontType${idx}`,
		fontWeight = `fontWeight${idx}`,
		FontSize = `FontSize${idx}`,
		letterSpacing = `letterSpacing${idx}`,
		lineHeight = `lineHeight${idx}`,
		TopSpace = `TopSpace${idx}`,
		BottomSpace = `BottomSpace${idx}`,
		errorfile = `errorfile${idx}`;
		return ( <>
		  <div className="form-row mb-0" key={val.index}>
				  <div className='form-left'>			
				<div className="form-group"  >					
					<label className='pb-0'>
						

						Font Apply to {this.Capitalize(val.fontType)}
						
						
						</label>	
					
					<div className='mt-2'>{val.FontTypeCheck}</div>				
				</div>
				</div>
			</div>
			<div className="form-row" key={val.index}>	
				
				{this.varientField(val.font_id, val.fontFamily, val.fontType,idx,val,val.index)}
			  </div>
		  </>
		);
	  });
}




handleFileChangeVarients = async  (e, idx,fontLabel, fontValue) => {
	let	font_file = `font_file${idx}`;
	let fontDetails = [...this.state.fontDetails];
	console.log(e.target.value,'thisi si target value')
	fontDetails[idx] = {
        ...fontDetails[idx],
        fontWeight: e.target.value 
    };
	fontDetails[e.target.dataset.id]['varient_id'] = idx;	
	fontDetails[e.target.dataset.id][e.target.name] = e.target.value;
		let selectedFont = e.target.name;
	this.setState({ fontDetails }, () => {
        console.log(this.state.fontDetails, 'Updated fontDetails'); 
    });

};

addMoreFuncold = (e) => {	
	return this.state.fontDetails.map((val, idx) => {
		
		let FontType = `FontType${idx}`,
		fontWeight = `fontWeight${idx}`,
		FontSize = `FontSize${idx}`,
		letterSpacing = `letterSpacing${idx}`,
		lineHeight = `lineHeight${idx}`,
		TopSpace = `TopSpace${idx}`,
		BottomSpace = `BottomSpace${idx}`,
		errorfile = `errorfile${idx}`;
		return ( <>
		  <div className="form-row mb-0" key={val.index}>
				  <div className='form-left'>			
				<div className="form-group"  >					
					<label className='pb-0'>
						{/* Apply font : */}

						Font Apply to {this.Capitalize(val.fontType)}
						
						
						</label>	
					{/* <div className='d-flex align-items-center gap-3'>					
					<select name="FontType" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx)}>
						<option value="" className="fontVarientName" > Select Type</option>
						<option value="PrimaryFont" className="fontVarientName" selected={val.FontType=='PrimaryFont'?true:false} > Primary Font</option>
						<option value="mainTab" className="fontVarientName" selected={val.FontType=='mainTab'?true:false} > MainTab</option>
						<option value="sideMenu" className="fontVarientName" selected={val.FontType=='sideMenu'?true:false} > SideMenu</option>
						<option value="title" className="fontVarientName" selected={val.FontType=='title'?true:false} > Title</option>
						<option value="subTitle" className="fontVarientName" selected={val.FontType=='subTitle'?true:false}> SubTitle</option>
						<option value="button" className="fontVarientName"selected={val.FontType=='button'?true:false} > Button</option>
						<option value="smButton" className="fontVarientName" selected={val.FontType=='smButton'?true:false}> SmallButton</option>
						<option value="lgButton" className="fontVarientName" selected={val.FontType=='lgButton'?true:false}> LargeButton</option>										
					</select>						
					{idx === 0 ? (
					<span className="add_font_varients cursor-pointer"  onClick={() => this.addFunc()}><i class="fa fa-plus-circle fa-1x"></i></span> ) : 
					<span className="btn_remove cursor-pointer" onClick={() => this.deleteFunc(val)} ><i class="fa fa-trash fa-1x"></i></span>
					}	
					</div>	 */}
					<div className='mt-2'>{val.FontTypeCheck}</div>				
				</div>
				</div>
			</div>
			<div className="form-row" key={val.index}>	
				{this.varientField(val.font_id, val.fontFamily, val.fontType,idx,val,val.index)}
			  </div>
		  </>
		);
	  });
}
varientField = (FontId, FontFamily, FontType,idx,val,selIndex)=>{
		
	const fontArray = this.state.fonttype.map ((fonttype, index) => ({
	id: index,
	name: fonttype,
	}));

	// Dynamically create select list
	let fonts = [];
	fontArray.map(item =>
		fonts.push({ label: item.name.label, value: item.name.value , fontStyles: item.name.tf_fontStyles, typeIs: item.name.tf_font_type ,type:item.name.type}),
	);

	
	let fontWeight = `fontWeight${idx}`,
		FontSize = `FontSize${idx}`,
		FontIndId = `FontId${idx}`,
		letterSpacing = `letterSpacing${idx}`,
		lineHeight = `lineHeight${idx}`,
		TopSpace = `TopSpace${idx}`,
		BottomSpace = `BottomSpace${idx}`,
		LgButtonRadius = `lgButtonRadius${idx}`,
		openbutton = `openbutton${idx}`,
		
		errorfile = `errorfile${idx}`
		//if(FontType !=='smallButton' && FontType!=='largeButton'){
		return(
			<>
			<div className="form-left">
				<div className="form-group">
					<label>Font Family  :</label>
					<div>																
						

					<select
					name="font_id"
					className="form-control"
					id={FontType}
					data-id={idx}
					value={val.font_id?.toString() || ''}
					onChange={(e) => {
						const selectedValue = e.target.value;
						const selectedOption = fonts.find(option => option.value === selectedValue);
						this.handleFileChange(e, idx, selectedOption?.label, selectedOption?.value);
					}}
					>
				<option value="">Select Font</option>

				<optgroup label="System Fonts">
				{fonts
				.filter(f => f.type === 'system_font')
				.map(option => (
					<option key={option.value} value={option.value}>
					{option.label}
					</option>
				))}
				</optgroup>

				<optgroup label="Google Fonts">
				{fonts
				.filter(f => f.type === 'google_font')
				.map(option => (
					<option key={option.value} value={option.value}>
					{option.label}
					</option>
				))}
				</optgroup>
				{console.log(fonts,'this is for fonts label')}
				<optgroup label="Custom Fonts">
				{fonts
				.filter(f => f.type === 'normal_font')
				.map(option => (
					<option key={option.value} value={option.value}>
					{option.label}
					</option>
				))}
				</optgroup>
				</select>
						<div className={errorfile}></div> 						
					</div>
				</div>	
			</div>
			<div className="form-right">
				<div className="form-group">
					<label>Font Variant :</label>
					<div>
						<select 
							name="fontWeight" 
							className="form-control" 
							id={FontType} 
							data-id={idx} 
							onChange={(e) => this.handleFileChangeVarients(e, idx)}
						>
							<option value="" className="fontVarientName">Select Variant</option>
								
							{this.state.fontDetails[idx]?.variants?.map((variant) => (
								<option 
									key={variant.value} 
									value={variant.value || val.fontWeight} 
									selected={val.fontWeight == variant.value ? true : false}
								>
									{variant.label} {variant.value}
								</option>
							))}
						</select>	

						<div className={errorfile}></div>
					</div>
				</div>
			</div>

			{/* <div className="form-right">
				<div className="form-group">
					<label>Font Variant :</label>
					<div>
						 <select name="fontWeight" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx)}>
						<option value="" className="fontVarientName" > Select Variant</option>
						<option value="200" className="fontVarientName" selected={val.fontWeight=='200'?true:false} > Extra Light200</option>
						<option value="300" className="fontVarientName" selected={val.fontWeight=='300'?true:false}> Light 300</option>
						<option value="400" className="fontVarientName" selected={val.fontWeight=='400'?true:false}> Regular 400</option>
						<option value="500" className="fontVarientName" selected={val.fontWeight=='500'?true:false}> Medium 500</option>
						<option value="600" className="fontVarientName" selected={val.fontWeight=='600'?true:false} > Semi Bold 600</option>
						<option value="700" className="fontVarientName" selected={val.fontWeight=='700'?true:false}> Bold 700</option>
						<option value="800" className="fontVarientName" selected={val.fontWeight=='800'?true:false}> Extra Bold 800</option>
						<option value="900" className="fontVarientName" selected={val.fontWeight=='900'?true:false}>Black 900</option>
										
						</select>	 


															
						<div className={errorfile}></div> 
					</div>
				</div>	
			</div>	 */}
			<div className="form-left">
				<div className="form-group">
					<label>Font Size  :</label>
					<div>
						<input type="text" name="fontSize" 
						onChange={(e) => this.handleFileChange(e, idx)} 
						//onChange={this.onFileChange}
						value={val.fontSize}

						data-id={idx}
						id={FontSize}    /> 
									
						<div className={errorfile}></div> 
					</div>
				</div>	
			</div>
			<div className="form-right">
				<div className="form-group">
					<label>Letter Spacing  :</label>
					<div>
						<input type="text" name="letterSpacing" 
						onChange={(e) => this.handleFileChange(e, idx)} 
						//onChange={this.onFileChange}
						value={val.letterSpacing}

						data-id={idx}
						id={letterSpacing}    /> 
									
						<div className={errorfile}></div> 
					</div>
				</div>	
			</div>
			
				{

						
					(FontType =='smallButton' || FontType=='largeButton' || FontType=='openbutton' ) ?
						<>
						<div className="form-left">
							<div className="form-group">
								<label>Top Space :</label>
								<div>
									<input type="text" name="topSpace" 
									onChange={(e) => this.handleFileChange(e, idx)} 
									value={val.topSpace}
									data-id={idx}
									id={TopSpace}    /> 
												
									<div className={errorfile}></div> 
								</div>
							</div>	
						</div>
						<div className="form-right">
							<div className="form-group">
								<label>Bottom Space :</label>
								<div>
									<input type="text" name="bottomSpace" 
									onChange={(e) => this.handleFileChange(e, idx)} 
									value={val.bottomSpace}
									data-id={idx}
									id={BottomSpace}    /> 									
									<div className={errorfile}></div> 
								</div>
							</div>	
						</div>	
						
						<div className="form-left">
								<div className="form-group">
									<label>Radius :</label>
									<div>
										<input type="text" name="lgButtonRadius" 
										onChange={(e) => this.handleFileChange(e, idx)} 
										value={val.lgButtonRadius}
										data-id={idx}
										id={LgButtonRadius}    /> 
													
										<div className={errorfile}></div> 
									</div>
								</div>	
							</div>
							
						</>
					: ''
				}
			</>);
		

}

varientFieldold1 = (FontId, FontFamily, FontType,idx,val,selIndex)=>{
		
	const fontArray = this.state.fonttype.map ((fonttype, index) => ({
	id: index,
	name: fonttype,
	}));
	// Dynamically create select list
	let fonts = [];
	fontArray.map(item =>
		fonts.push({ label: item.name.label, value: item.name.value , fontStyles: item.name.tf_fontStyles, typeIs: item.name.tf_font_type }),
	);

	
	let fontWeight = `fontWeight${idx}`,
		FontSize = `FontSize${idx}`,
		FontIndId = `FontId${idx}`,
		letterSpacing = `letterSpacing${idx}`,
		lineHeight = `lineHeight${idx}`,
		TopSpace = `TopSpace${idx}`,
		BottomSpace = `BottomSpace${idx}`,
		errorfile = `errorfile${idx}`
		//if(FontType !=='smallButton' && FontType!=='largeButton'){
		return(
			<>
			<div className="form-left">
				<div className="form-group">
					<label>Font Family  :</label>
					<div>																
						<select name="font_id" className="form-control" id={FontType} data-id={idx} onChange={(e) => {
									const selectedValue = e.target.value;
									const selectedOption = fonts.find(option => option.value === selectedValue);
									console.log(selectedOption,'thisi is filter data')
									this.handleFileChange(e, idx, selectedOption?.label, selectedOption?.value);
								}}>
							<option value="" className="fontFamilyId" > Select Font</option>			
							{fonts.map((option) => (
								
							<option key={option.value} value={option.value}  selected={val.font_id==option.value?true:false}>
								{option.label}
							</option>
							))}
						</select>	
						<div className={errorfile}></div> 						
					</div>
				</div>	
			</div>
			<div className="form-right">
				<div className="form-group">
					<label>Font Variant :</label>
					<div>
						<select 
							name="fontWeight" 
							className="form-control" 
							id={FontType} 
							data-id={idx} 
							onChange={(e) => this.handleFileChangeVarients(e, idx)}
						>
							<option value="" className="fontVarientName">Select Variant</option>
								{console.log(this.state.fontDetails,'this is fontsdetails')}
							{this.state.fontDetails[idx]?.variants?.map((variant) => (
								<option 
									key={variant.value} 
									value={variant.value || val.fontWeight} 
									selected={val.fontWeight == variant.value ? true : false}
								>
									{variant.label} {variant.value}
								</option>
							))}
						</select>	

						<div className={errorfile}></div>
					</div>
				</div>
			</div>

			{/* <div className="form-right">
				<div className="form-group">
					<label>Font Variant :</label>
					<div>
						 <select name="fontWeight" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx)}>
						<option value="" className="fontVarientName" > Select Variant</option>
						<option value="200" className="fontVarientName" selected={val.fontWeight=='200'?true:false} > Extra Light200</option>
						<option value="300" className="fontVarientName" selected={val.fontWeight=='300'?true:false}> Light 300</option>
						<option value="400" className="fontVarientName" selected={val.fontWeight=='400'?true:false}> Regular 400</option>
						<option value="500" className="fontVarientName" selected={val.fontWeight=='500'?true:false}> Medium 500</option>
						<option value="600" className="fontVarientName" selected={val.fontWeight=='600'?true:false} > Semi Bold 600</option>
						<option value="700" className="fontVarientName" selected={val.fontWeight=='700'?true:false}> Bold 700</option>
						<option value="800" className="fontVarientName" selected={val.fontWeight=='800'?true:false}> Extra Bold 800</option>
						<option value="900" className="fontVarientName" selected={val.fontWeight=='900'?true:false}>Black 900</option>
										
						</select>	 


															
						<div className={errorfile}></div> 
					</div>
				</div>	
			</div>	 */}
			<div className="form-left">
				<div className="form-group">
					<label>Font Size  :</label>
					<div>
						<input type="text" name="fontSize" 
						onChange={(e) => this.handleFileChange(e, idx)} 
						//onChange={this.onFileChange}
						value={val.fontSize}

						data-id={idx}
						id={FontSize}    /> 
									
						<div className={errorfile}></div> 
					</div>
				</div>	
			</div>
			<div className="form-right">
				<div className="form-group">
					<label>Letter Spacing  :</label>
					<div>
						<input type="text" name="letterSpacing" 
						onChange={(e) => this.handleFileChange(e, idx)} 
						//onChange={this.onFileChange}
						value={val.letterSpacing}

						data-id={idx}
						id={letterSpacing}    /> 
									
						<div className={errorfile}></div> 
					</div>
				</div>	
			</div>
			{console.log(FontType,'thi is fonttype')}
				{

						
					(FontType =='smallButton' || FontType=='largeButton') ?
						<>
						<div className="form-left">
							<div className="form-group">
								<label>Top Space :</label>
								<div>
									<input type="text" name="topSpace" 
									onChange={(e) => this.handleFileChange(e, idx)} 
									value={val.topSpace}
									data-id={idx}
									id={TopSpace}    /> 
												
									<div className={errorfile}></div> 
								</div>
							</div>	
						</div>
						<div className="form-right">
							<div className="form-group">
								<label>Bottom Space :</label>
								<div>
									<input type="text" name="bottomSpace" 
									onChange={(e) => this.handleFileChange(e, idx)} 
									value={val.bottomSpace}
									data-id={idx}
									id={BottomSpace}    /> 									
									<div className={errorfile}></div> 
								</div>
							</div>	
						</div>	
						</>
					: ''
				}
			</>);
		

  }
varientFieldold = (FontId, FontFamily, FontType,idx,val,selIndex)=>{
	
	const fontArray = this.state.fonttype.map ((fonttype, index) => ({
	id: index,
	name: fonttype,
	}));
	// Dynamically create select list
	let fonts = [];
	fontArray.map(item =>
		fonts.push({ label: item.name.label, value: item.name.value , fontStyles: item.name.tf_fontStyles, typeIs: item.name.tf_font_type }),
	);

	console.log(fontArray);

	let fontWeight = `fontWeight${idx}`,
		FontSize = `FontSize${idx}`,
		FontIndId = `FontId${idx}`,
		letterSpacing = `letterSpacing${idx}`,
		lineHeight = `lineHeight${idx}`,
		TopSpace = `TopSpace${idx}`,
		BottomSpace = `BottomSpace${idx}`,
		errorfile = `errorfile${idx}`
		//if(FontType !=='smallButton' && FontType!=='largeButton'){
		return(
			<>
			<div className="form-left">
				<div className="form-group">
					<label>Font Family  :</label>
					<div>																
						{/* <Select 
							options={fonts}  
							value={FontFamily}
							//onChange={this.handleChangeFont}
							placeholder="Select Font Type" 
							name="FontFamily" 
							id={FontIndId} 
							data-id={idx} 								
							onChange={(e) => this.handleFileChange(e, idx)}
						/> */}

						<select name="font_id" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx,selIndex)}>

						<option value="" className="fontFamilyId" > Select Font</option>	
										
						{fonts.map((option) => (
							
						<option key={option.value} value={option.value}  selected={val.font_id==option.value?true:false}>
							{option.label}
						</option>
						))}
						</select>	
						<div className={errorfile}></div> 						
					</div>
				</div>	
			</div>
			<div className="form-right">
				<div className="form-group">
					<label>Font Variant :</label>
					<div>
						 <select name="fontWeight" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx)}>

						<option value="" className="fontVarientName" > Select Variant</option>
						<option value="200" className="fontVarientName" selected={val.fontWeight=='200'?true:false} > Extra Light200</option>
						<option value="300" className="fontVarientName" selected={val.fontWeight=='300'?true:false}> Light 300</option>
						<option value="400" className="fontVarientName" selected={val.fontWeight=='400'?true:false}> Regular 400</option>
						<option value="500" className="fontVarientName" selected={val.fontWeight=='500'?true:false}> Medium 500</option>
						<option value="600" className="fontVarientName" selected={val.fontWeight=='600'?true:false} > Semi Bold 600</option>
						<option value="700" className="fontVarientName" selected={val.fontWeight=='700'?true:false}> Bold 700</option>
						<option value="800" className="fontVarientName" selected={val.fontWeight=='800'?true:false}> Extra Bold 800</option>
						<option value="900" className="fontVarientName" selected={val.fontWeight=='900'?true:false}>Black 900</option>
										
						</select>	 


															
						<div className={errorfile}></div> 
					</div>
				</div>	
			</div>	
			<div className="form-left">
				<div className="form-group">
					<label>Font Size  :</label>
					<div>
						<input type="text" name="fontSize" 
						onChange={(e) => this.handleFileChange(e, idx)} 
						//onChange={this.onFileChange}
						value={val.fontSize}

						data-id={idx}
						id={FontSize}    /> 
									
						<div className={errorfile}></div> 
					</div>
				</div>	
			</div>
			<div className="form-right">
				<div className="form-group">
					<label>Letter Spacing  :</label>
					<div>
						<input type="text" name="letterSpacing" 
						onChange={(e) => this.handleFileChange(e, idx)} 
						//onChange={this.onFileChange}
						value={val.letterSpacing}

						data-id={idx}
						id={letterSpacing}    /> 
									
						<div className={errorfile}></div> 
					</div>
				</div>	
			</div>
			{console.log(FontType,'thi is fonttype')}
				{

						
					(FontType =='smallButton' || FontType=='largeButton') ?
						<>
						<div className="form-left">
							<div className="form-group">
								<label>Top Space :</label>
								<div>
									<input type="text" name="topSpace" 
									onChange={(e) => this.handleFileChange(e, idx)} 
									value={val.topSpace}
									data-id={idx}
									id={TopSpace}    /> 
												
									<div className={errorfile}></div> 
								</div>
							</div>	
						</div>
						<div className="form-right">
							<div className="form-group">
								<label>Bottom Space :</label>
								<div>
									<input type="text" name="bottomSpace" 
									onChange={(e) => this.handleFileChange(e, idx)} 
									value={val.bottomSpace}
									data-id={idx}
									id={BottomSpace}    /> 									
									<div className={errorfile}></div> 
								</div>
							</div>	
						</div>	
						</>
					: ''
				}
			</>);
		//}
		// if(FontType =='smallButton' || FontType=='largeButton'){
		// 	return(<>
		// 	<div className="form-left">
		// 		<div className="form-group">
		// 			<label>Top Space :</label>
		// 			<div>
		// 				<input type="text" name="TopSpace" 
		// 				onChange={(e) => this.handleFileChange(e, idx)} 
		// 				value={val.topSpace}
		// 				data-id={idx}
		// 				id={TopSpace}    /> 
									
		// 				<div className={errorfile}></div> 
		// 			</div>
		// 		</div>	
		// 	</div>
		// 	<div className="form-right">
		// 		<div className="form-group">
		// 			<label>Bottom Space :</label>
		// 			<div>
		// 				<input type="text" name="BottomSpace" 
		// 				onChange={(e) => this.handleFileChange(e, idx)} 
		// 				value={val.bottomSpace}
		// 				data-id={idx}
		// 				id={BottomSpace}    /> 									
		// 				<div className={errorfile}></div> 
		// 			</div>
		// 		</div>	
		// 	</div>	
		// 	</>);
		// }

}
Capitalize(str){
	if(str){
		return str.charAt(0).toUpperCase() + str.slice(1);
	}
	
}
handleFileChangeold = (e, idx) => {
	let	font_file = `font_file${idx}`;
	let fontDetails = [...this.state.fontDetails];
	fontDetails[e.target.dataset.id]['varient_id'] = idx;	
	fontDetails[e.target.dataset.id][e.target.name] = e.target.value;
	
	this.setState({
			fontDetails: 			  
			  fontDetails
		  });

};

handleFileChange = async  (e, idx,fontLabel, fontValue) => {
	let	font_file = `font_file${idx}`;
	let fontDetails = [...this.state.fontDetails];
	
	
	fontDetails[e.target.dataset.id]['varient_id'] = idx;	
	fontDetails[e.target.dataset.id][e.target.name] = e.target.value;
		let selectedFont = e.target.name;

		

		console.log(fontValue,'this is selectedfont',fontLabel)
	if (fontValue) {
        try {
            const response = await axios.get(`${apiUrl}font/getvarientlistdetail`, {
				params: {
					id: fontValue,     
					name: fontLabel     
				}
			});
            if (response.data.variants) {
                fontDetails[idx] = { 
                    ...fontDetails[idx], 
                    variants: response.data.variants  
                };
				console.log(response.data.variants,'this is fortvarientrecords')
            }
        } catch (error) {
            console.error("Error fetching font variants:", error);
        }
    }

	this.setState({ fontDetails }, () => {
        console.log(this.state.fontDetails, 'Updated fontDetails'); 
    });

};
Capitalize(str){
    return str.charAt(0).toUpperCase() + str.slice(1);
}

handleChangeAllmodelguest = selectedallmodel => {
	this.setState({ selectedallmodel});
	this.setState({ selectedallmodelvalue : selectedallmodel.value });	
	}
	handleCancel = () => {
		const popup = document.querySelector('.input-popup-action');
		if (popup) {
		  popup.classList.remove('show');
		}
	  };
		handleSubmit = () => {
			const popup = document.querySelector('.input-popup-action');
			if (popup) {
			popup.classList.remove('show');
			}
	  };

handleShadowChange = (value) => {
	
	
    this.setState((prevState) => ({
      shadows: {
        ...prevState.shadows,
        [this.state.activeShadowType]: value,
      },
    }));
  };


               
		labelFor = (key) => {
  			const labels = {
			pluginShadow:'Plugin Shadow',
			 pluginInsideLeftShadow: "Plugin Inside Left Shadow",
			pluginInsideRightShadow: "Plugin Inside Right Shadow",
			pluginInsideTopShadow: "Plugin Inside Top Shadow",
			pluginInsideBottomShadow: "Plugin Inside Bottom Shadow",
			dashboardShadowGrid:"Dashboard Grid Shadow",
			dashboardShadowList:"Dashboard List Shadow",
			sideMenu:"Sidemenu Shadow (Side Menu, Chat window)",
			shortcutMenu: "Shortcut Menu Shadow (Shotcut menu, AI screen textarea)",
			largeButton: "Button Shadow",
			// smallButton: "Small Button Shadow",   
			// sidePopup: "Side Popup Shadow",
			textarea: "Textarea Shadow (Address field, Result )",
			openButton: 'Open Button Shadow',
			shadowAISidebar: "AI Sidebar Shadow",
			pluginInset: "Plugin Inside Shadow",
			dropdownmenu: "Dropdown Menu Shadow (Bell notification, Group menu in listing screen, Address dropdown)",
			shadowListRow: "List Shadow",
			shadowTableRow: "Table Shadow",
			shadowMapPopup:"Map Popup Shadow (View Map) ",
			shadowRightSidebar:"Right sidebar",
			shadowLeftSidebar:"Left sidebar",
			

  			};
  			return labels[key] || key;
		};
		
		handleInputChangeShadows = (type, value) => {
			console.log(type,'this  type and value',value)
		this.setState((prevState) => ({
			shadows: {
			...prevState.shadows,
			[type]: value
			}
		}));
		};
		confirmPopup = (key) =>{
			this.setState({
				activeShadowType: key
			});
			$('.input-popup-action').addClass('show');
		}
		handleChangeTabView = (selectedOption) => {
 			 this.setState({ showTab: selectedOption.value });
		}
		handlePositionChange = (selectedOption) => {
  this.setState({ st_position: selectedOption.value },()=>{
	if(selectedOption.value =='absolute'){
		$('.d-height').removeClass('d-none');
	}else{
		$('.d-height').addClass('d-none');
	}
  });
};	

  render() {
	 
	const loaderimg = mediaUrl+'/'+'eta_image'+'/'+this.state.image_name;
	var	preview = <img className="img_class" src={loaderimg} alt="" />;
  
	if(this.state.cancellation_fees_type == 'flat')
		{
			$('.cancellation_fee').html('Cancellation fees ($):')
			
		}else{
			$('.cancellation_fee').html('Cancellation fees (%):')
		}	
		if(this.state.reschedule_fees_type == 'flat')
		{
			$('.reschedule_fee').html('Reschedule fees ($):')
			
		}else{
			$('.reschedule_fee').html('Reschedule fees (%):')
		}	
	let test1 = this.state.settings_access_code;
	//let test = Number(this.state.settings_access_code);
	
	const scripttype = '';
	
		/*const tester =	'<!-- Include <div> tag after the script -->\n<script src="http://car-c.uxt.design/plugin.js"></script>\n<div data-client="'+test+'"  id="car_container"></div>';
		*/
		
		
	let  tester =	'<script src="https://admin.rx.one/plugin.js"></script> <div data-client="'+test1+'"  id="RX_container"></div>';


	const fontArray = this.state.fonttype.map ((fonttype, index) => ({
	id: index,
	name: fonttype,
	}));
	// Dynamically create select list
	let fonts = [];
	fontArray.map(item =>
	fonts.push({ label: item.name.label, value: item.name.value }),
	);

	const {selectedFont,selectedapptduration,selectedplugingwidth,selectedfaqmodeluser,selectedfaqmodelguest,selectedfaqmodellux,selectedfaqmodelcompany,selectedfaqmodelcommon} = this.state;

	const style_text = {
	color: 'white',
    backgroundColor: '#000',
    padding: '9px 9px',
    minwidth: '49px',
    height: '37px',
	textalign:'center',
    texttransform: 'capitalize'
}

	if(this.state.cancellation_fees_type == 'flat')
	{
		$('.cancellation_fee').html('Cancellation fees ($):')
		
	}else{
		$('.cancellation_fee').html('Cancellation fees (%):')
	}	
	if(this.state.reschedule_fees_type == 'flat')
	{
		$('.reschedule_fee').html('Reschedule fees ($):')
		
	}else{
		$('.reschedule_fee').html('Reschedule fees (%):')
	}	
	var refresh_token = this.state.dr_refresh_token;
	var yourclientid = this.state.drchrono_client_id;
	if(this.state.drchrono_client_id =='' && this.state.drchrono_client_secret_key =='' ){

		refresh_token = "";

	}

	if(this.state.drchrono_client_id =='' ){


		yourclientid = "YOUR_CLIENT_ID";
	}

	const {selectedallmodel} = this.state;

	
    return (
      <div className="wrapper"> 
 
	  <Header />
	  <MenuSidebar currentpage="setting" />		

	
	<div className="content">	
		<div className="content-wrapper">
		  <div class="content-wrapper-before"></div>
			<div className="content-body setting-main-head leaa-admin-head card">
			<form className="settings" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }}>
			<div className="form-wrapper">
			<div className="success_message"></div>
			<div className="title">
				<h4>Settings</h4>
			</div>
			<div className="form-row">
			<div className="form-left">
				<div className="form-group">
				{localStorage.getItem('admin_id') == 1 ?<label>Site Name<span class="required" style={{ color: "red" }} >* </span></label>:<label>Company Name<span class="required" style={{ color: "red" }} >* </span></label>}
					
					<input type="text" name="settings_site_title" onChange={this.handleInputChange} className="form-control" value={this.state.settings_site_title} />
					<div className="errorsettings_site_title"></div>
				</div>
				<div className="form-group">					
					<label>From Name<span class="required" style={{ color: "red" }} >* </span></label>
					<input type="text" name="settings_from_name" onChange={this.handleInputChange} className="form-control"value={this.state.settings_from_name} />
					<div className="errorsettings_from_name"></div>
				</div>
				<div className="form-group">
					<label>From Email<span class="required" style={{ color: "red" }} >* </span></label>
					<input type="text" name="settings_from_email"  onChange={this.handleInputChange} className="form-control" value={this.state.settings_from_email} />
					<div className="errorsettings_from_email"></div>
				</div>
			
				

				
			

			
			</div>
			<div className="form-right">

				<div className="form-group">					
				{localStorage.getItem('admin_id') == 1 ? <label>Admin Email<span class="required" style={{ color: "red" }} >* </span></label>:<label>Company Email:</label>} 
					<input type="text" className="form-control" onChange={this.handleInputChange} name="settings_admin_email" value={this.state.settings_admin_email} />
					<div className="errorsettings_admin_email"></div>
				</div>
				
				<div className="form-group">
					<label>Contact<span class="required" style={{ color: "red" }} >* </span></label>
					<input type="text" className="form-control" name="settings_mobileno"  onChange={this.handleInputChange} value={this.state.settings_mobileno}/>
					<div className="errorsettings_mobileno"></div>
				</div>

				<div className="form-group"> 
					<label>Email Footer Content<span class="required" style={{ color: "red" }} >* </span></label>
					<input type="text" className="form-control" name="settings_email_footer" onChange={this.handleInputChange} value={this.state.settings_email_footer}/>
					<div className="errorsettings_email_footer"></div>
				</div>
				
						
				



				  
			</div>				
			</div>	
		    <div className="title">
				<h4>Mail Configuration Settings</h4>
			</div> 
			
			 <div className="form-group">
				    <input onChange={this.handleInputChange} type="checkbox"  name="settings_mail_from_smtp" checked={this.state.smtp_checked}/>
	                <span>Send Mail From Smtp</span>
            </div> 

		 <div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Smtp Host:</label>
					<input type="text" className="form-control" name="settings_smtp_host" onChange={this.handleInputChange}  value={(this.state.settings_smtp_host != 'null')?this.state.settings_smtp_host:''}/>
					<div className="errorsettings_smtp_host"></div>
				</div>
				<div className="form-group">					
					<label>Smtp Username:</label>
					<input type="text" className="form-control" name="settings_smtp_user"  onChange={this.handleInputChange}  value={(this.state.settings_smtp_user != 'null')?this.state.settings_smtp_user:''} />
					<div className="errorsettings_smtp_user"></div>
				</div>					
				<div className="form-group">
					<label>Smtp Password:</label>
					<input type="password" className="form-control" name="settings_smtp_pass" onChange={this.handleInputChange}  value={(this.state.settings_smtp_pass != 'null')?this.state.settings_smtp_pass:''} />
				<div className="errorsettings_smtp_pass"></div>
				</div>
			</div>			
			<div className="form-right">
				<div className="form-group">					
					<label>Smtp Port:</label>
					<input type="text" className="form-control"  name="settings_smtp_port" onChange={this.handleInputChange}  value={(this.state.settings_smtp_port != 'null')?this.state.settings_smtp_port:''} />
				<div className="errorsettings_smtp_port"></div>
				</div>
				<div className="form-group"> 
					<label>Mail Path:</label>
					<input type="text" className="form-control" name="settings_mailpath" onChange={this.handleInputChange} placeholder=""  value={(this.state.settings_mailpath != 'null')?this.state.settings_mailpath:''}/>
				</div>
			</div>	
			</div> 
				


				{/* -------------chat ai setting start-------------- */}

			<div className="title">
				<h4>Chat AI Setting</h4>
		   </div> 

			<div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Chat AI type: </label>					
				</div>
				<div className="form-group">
					<label>Chat Model: </label>					
				</div>
				{/* <div className="form-group">
					<label>Common / Guest Conversation</label>					
				</div>

				<div className="form-group">
					<label>User Conversation</label>					
				</div>
				
				<div className="form-group">
					<label>RX Conversation</label>					
				</div>
				<div className="form-group">
					<label>Company Conversation</label>					
				</div> */}
				<div className="form-group">
					<label>API Key</label>					
				</div>
					<div className="form-group">
					<label>ChatGPT Model ID</label>
										
					</div>
					<div className="form-group">
							<label>Chat Name</label>
					</div>
					<div className="form-group">
							<label> Chat Screen width <span class="required" style={{ color: "red" }} >(Px) </span> </label>
					</div>
						
			</div> 

			
			<div className="form-right">
				<div className="form-group">						
					<input onChange={this.handleInputChange} type="radio" name="aichat_type" checked={this.state.aichat_type=='text'?'chekced':''} value="text"/>
					<span>Text</span>
						<input onChange={this.handleInputChange} type="radio"  name="aichat_type" checked={this.state.aichat_type=='chat'?'chekced':''} value="chat"/>
					<span>Chat </span>
				</div> 

					<div className="form-group">					
						
						<Select 
							className="z-index-999"
							options={this.state.faqmodelcommon}  
							value={selectedfaqmodelcommon?selectedfaqmodelcommon:{ value: '0', label: 'Select an ai model' }}
							onChange={this.handleChangeAimodelcommon}
							placeholder="Select AI Model ID" 
						/>			
					</div>

			{/* <div className="form-group">					
				
				<Select 
					options={this.state.faqmodelguest}  
					value={selectedfaqmodelguest?selectedfaqmodelguest:{ value: '0', label: 'Select guest ai model' }}
					onChange={this.handleChangeAimodelguest}
					placeholder="Select AI Model ID" 
				/>			
			</div> */}

			{/* <div className="form-group">					
				<Select 
					options={this.state.faqmodeluser}  
					value={selectedfaqmodeluser?selectedfaqmodeluser:{ value: '0', label: 'Select user ai model' }}
					onChange={this.handleChangeAimodeluser}
					placeholder="Select AI Model ID" 
				/>			
			</div>		 */}

			{/* <div className="form-group">					
				<Select 
					options={this.state.faqmodellux}  
					value={selectedfaqmodellux?selectedfaqmodellux:{ value: '0', label: 'Select lux ai model' }}
					onChange={this.handleChangeAimodellux}
					placeholder="Select AI Model ID" 
				/>			
			</div>	 */}
			{/* <div className="form-group">					
				<Select  
					options={this.state.faqmodelcompany}  
					value={selectedfaqmodelcompany?selectedfaqmodelcompany:{ value: '0', label: 'Select company ai model' }}
					onChange={this.handleChangeAimodelcompany}
					placeholder="Select AI Model ID" 
				/>			
			</div>	 */}

			<div className="form-group">					
				<input type="text" className="form-control" name="chat_api_key" onChange={this.handleInputChange} value={this.state.chat_api_key}/>
				<div className="errorsettings_chat_api_key"></div>		
			</div>	

			<div className="form-group">		
					<Select 
						options={this.state.all_models}  
						value={selectedallmodel?selectedallmodel:{ value: '0', label: 'Select ai model' }}
						onChange={this.handleChangeAllmodelguest}
						placeholder="Select AI Model ID" 
					/>	
				<div className="errorchat_model"></div>
				</div>

					<div className="form-group">
						<input type="text" className="form-control" name="chat_name"  onChange={this.handleInputChange} value={this.state.chat_name}/>
						<div className="errorsettings_chat_name"></div>
					</div>
					<div className="form-group">
						<input type="text" className="form-control" name="chat_screen_width"  onChange={this.handleInputChange} value={this.state.chat_screen_width}/>
						<div className="errorsettings_chat_name"></div>
					</div>
			</div>
      	</div>
		{/* -------------chat ai setting end-------------- */}

		{/* <div className="title">
				<h4>Feed domain data</h4>
		</div> */}

		{/* <div className="form-group">					
					<label>Type</label>
						   <input type="radio" name='type' value="text"  checked={this.state.completion_type === 'text'} onChange={this.handleInputChange}/> Prompt Text 
						   <input type="radio" name='type' value="chat" checked={this.state.completion_type === 'chat'} onChange={this.handleInputChange}/> Assistant Chat 
	           </div>  
		
		<div className="form-group">	
						<CKEditor
							editor={ ClassicEditor }
							data={(this.state.finetune_content) ? this.state.finetune_content : ''}
							onReady={ editor => {
								// You can store the "editor" and use when it is needed.
							} }
							onChange={ ( event, editor ) => {
								const data = editor.getData();
								this.setState({description: data});
								
							} }
						/>
					<div className="errordescription"></div>
					<button className='ai-feedbtn' onClick={this.handleSave}>AI Feed</button>
				</div>		
	     */}
			 

	    {/*AI Teaching******************************* start */}

		<div className="title">
				<h4>Domain & Embed Code</h4>
			</div> 
		<div className="form-row">
				<div className="form-left">
				<div className="form-group">
						<label>Embed Code<span class="required" style={{ color: "red" }} >* </span></label>
						<p className="right-side-header"  id="embed_code" name="settings_embedcode" value={tester} title="Copy Text" >{tester}</p>
						<br></br>
						<a id='copytext' style={style_text} onClick={this.writeText}   >Copy  </a> <br></br>
						<div><br></br><div className="copied_title"></div></div>
						<div className="errorsettings_embedcode_title"></div>
					</div>
					
					<div className='form-group'>
				     <h4>Google Analytics code </h4>
					 <textarea type="text" name="google_analystic_code" onChange={this.handleInputChange} className="form-control" value={this.state.google_analystic_code} />
					</div>
				</div>	
				<div className="form-right">
				    <div className='form-group'>
					<h4>Domain<span class="required" style={{ color: "red" }} >* </span></h4>
				    <div className="domain-url">
					<Addinputsimple myCallback={this.myCallback} domainname={this.state.domainSets} domain_count = {this.state.domain_count}/>
					</div>
					<div className="errorsettings_domain"></div>
					</div>
				</div>				
			</div>
			<div className='form-row'>
						<div className="form-left">
							{/*<div className="form-group">
								<label>Position : </label>
								<input onChange={this.handleInputChange} type="checkbox"  name="st_position" checked={this.state.st_position_checked}/>
								<span>Fixed</span>
							</div>*/}
							<div className="form-group">
									<label>Plugin Position:</label><br/>
									<Select
											name="st_position"
											value={lang.common.pluginPosition.find(
												option => option.value === this.state.st_position
											)}
											options={lang.common.pluginPosition}
											onChange={this.handlePositionChange}
									/>
								</div>
						</div>
						<div className="form-right">
						<div className="form-group d-height d-none">
						<label>Plugin Height</label>
						<input type="text" className="form-control" name="st_plugin_height"  onChange={this.handleInputChange} value={this.state.st_plugin_height}/>
						<div className="errorst_st_plugin_height"></div>
					</div>
						</div>
				</div>
			 <h5>Plugin Position (Numbers Only)</h5> 
			 <div className="form-row">			
				<div className="form-left">
					<div className="form-group">
						<label>Left : %</label>
						<input type="number" className="form-control" name="st_position_left"  onChange={this.handleInputChange} value={this.state.st_position_left}/>
						<div className="errorsettings_st_position_left"></div>
					</div>
					<div className="form-group">
						<label>Right : %</label>
						<input type="number" className="form-control" name="st_position_right"  onChange={this.handleInputChange} value={this.state.st_position_right}/>
						<div className="errorsettings_st_position_right"></div>
					</div>
					
					
				</div>
				<div className="form-right">
					<div className="form-group">
						<label>Top: %</label>
						<input type="number" className="form-control" name="st_position_top"  onChange={this.handleInputChange} value={this.state.st_position_top}/>
						<div className="errorsettings_st_position_top"></div>
					</div>
					<div className="form-group">
						<label>Bottom: %</label>
						<input type="number" className="form-control" name="st_position_bottom"  onChange={this.handleInputChange} value={this.state.st_position_bottom}/>
						<div className="errorsettings_st_position_bottom"></div>
					</div>
					

					

				</div>
			</div> 

			<div className="title">
				<h2>Plugin Inner Space</h2>
			</div>
			 <div className="form-row">			
				<div className="form-left">	
					<div className="form-group">
						<label>Top Px</label>
						<input type="number" className="form-control" name="st_inner_position_top"  onChange={this.handleInputChange} value={this.state.st_inner_position_top}/>
						<div className="errorsettings_st_position_top"></div>
					</div>
					<div className="form-group">
						<label>Bottom Px</label>
						<input type="number" className="form-control" name="st_inner_position_bottom"  onChange={this.handleInputChange} value={this.state.st_inner_position_bottom}/>
						<div className="errorsettings_st_inner_position_bottom"></div>
					</div>
				</div>
				<div className="form-right">
					<div className="form-group">
						<label>Left Px</label>
						<input type="number" className="form-control" name="st_inner_position_left"  onChange={this.handleInputChange} value={this.state.st_inner_position_left}/>
						<div className="errorsettings_st_position_left"></div>
					</div>
					<div className="form-group">
						<label>Right %</label>
						<input type="number" className="form-control" name="st_inner_position_right"  onChange={this.handleInputChange} value={this.state.st_inner_position_right}/>
						<div className="errorsettings_st_position_right"></div>
					</div>
				</div>
			</div>
			<div className="form-row">	
				<div className="form-left">
							<div className="form-group">					
					 <label>Plugin Width (Px)<span class="required" style={{ color: "red" }} >* </span></label>
						<Select 
							  options={lang.common.pluging_width}  
								value={selectedplugingwidth?selectedplugingwidth:{ value: '0', label: 'Select plugin width' }}
								onChange={this.handleChangePlugingwidth}
							
						/>		
					</div>
					<div className="form-group flex-align-center">
						<label className='w-50'>Show category icons: </label>
						<div className='w-50'>
					    <input onChange={this.handleInputChange} type="radio" name="category_icons" checked={this.state.category_icons_yes}/>
		                <span>Yes</span>
		                 <input onChange={this.handleInputChange} type="radio"  name="category_icons" checked={this.state.category_icons_no}/>
		                <span>No</span>
						</div>
 					</div> 
					 <div className="form-group flex-align-center">
         					 <label className='w-50'>Show Main Tab: </label>
							<div className='w-50'>
							<input
								onChange={this.handleInputChange}
								type="radio"
								name="tab_icons"
								value="yes"
								checked={this.state.tab_icons_yes}
							/>
         					<span>Yes</span>
							<input
								onChange={this.handleInputChange}
								type="radio"
								name="tab_icons"
								value="no"
								checked={this.state.tab_icons_no}
							/>
							<span>No</span>
							</div>
        			</div>
					 <div className="form-group flex-align-center justify-content-between">
						 <label className='w-50'>Dashboard View: </label>
						 <div className='w-50'>
							<input 
								onChange={this.handleInputddashbordview} 
								type="radio" 
								name="dashboard_view" 
								value="grid"
								checked={this.state.dashboardView === 'grid'} 
							/>
                   			 <span>Grid</span>
						<input 
							onChange={this.handleInputddashbordview} 
							type="radio" 
							name="dashboard_view" 
							value="list"
							checked={this.state.dashboardView === 'list'} 
						/>
					 	<span>List</span>
						</div>
 					</div> 
					<div className="form-group flex-align-center ">
						<label className='w-50'>Show Shortcut Icons: </label>
						<div className='w-50'>
							<input onChange={this.handleInputChange} type="radio" name="show_shortcut" checked={this.state.shortcut_icons_yes}  />
							<span>Yes</span>
							<input onChange={this.handleInputChange} type="radio" name="show_shortcut"  checked={this.state.shortcut_icons_no} />
							<span>No</span>
						</div>
					</div>
				</div>
				<div className="form-right">
							<div className="form-group">
						<label>Notification Popup Theme: </label>
						<br/>
					    <input onChange={this.handleInputChange} type="radio" name="np_theme" value="Black" checked={(this.state.np_theme == "Black" ? "checked" : "" )}/>
		                <span>Black bg with White text</span>
						<br/>
		                 <input onChange={this.handleInputChange} type="radio"  name="np_theme" value="White" checked={(this.state.np_theme == "White" ? "checked" : "" )}/>
		                <span>White bg with Black text</span>
 					</div>
					 <div class="form-group">
						<label>Appointment ETA Icon (jpeg,jpg,png,svg)<span class="required" >* </span></label>
						<div class="choose-file"><span class="profile_btn"><input type="file" name="file"  onChange={this.onChangeHandler}/></span>
						</div>
						{preview}
						{/* <img class="img_class" src="https://admin.rx.one/rxone/media/eta_image/car_(2).png" alt="" /> */}
						<div class="errorfile"></div>
					 </div>
					 <div className="form-group">
						<label >Landing Page: <span style={{ color: 'red' }}>*</span></label>
						<div >
							<Select
							options={lang.common.showTabOptions}
							value={lang.common.showTabOptions.find(option => option.value === this.state.showTab) || { value: '', label: 'Select tab' }}
							onChange={this.handleChangeTabView}
							/>
						</div>
						</div>
				</div>
			</div>
		
			<div className="title">
				<h4>Appointment Settings</h4>
			</div>  
			<div className="form-row">

			


				<div className="form-left">
					{/* <div className="form-group"> 
						<label className='location_distance'>Doctor Location Distance(mi)<span class="required" style={{ color: "red" }} > * </span>
						:</label>
						<input type="text" className="form-control" name="location_distance" onChange={this.handleInputChange} value={this.state.location_distance}/>
						<div className="errorsettings_location_distance"></div>
					</div> */}
					<div className="form-group">
						<label>Cancellation fees type: </label>
						<br></br>
						<input onChange={this.handleInputChange} type="radio" name="cancellation_fees_type" checked={this.state.cancellation_fees_type=='flat'?'chekced':''} value="flat"/>
						<span>Flat Amount </span>
							<input onChange={this.handleInputChange} type="radio"  name="cancellation_fees_type" checked={this.state.cancellation_fees_type=='percentage'?'chekced':''} value="percentage"/>
						<span>Percentage </span>
					</div> 
					<div className="form-group"> 
						<label className='cancellation_fee'>Cancellation fees<span class="required" style={{ color: "red" }} > * </span>
:</label>
						<input type="text" className="form-control" name="cancellation_fee" onChange={this.handleInputChange} value={this.state.cancellation_fee}/>
						<div className="errorsettings_cancellation_fee"></div>
					</div>

					<div className="form-group"> 
						<label>Cancellation Hours<span class="required" style={{ color: "red" }} > * </span>:</label>
						<input type="text" className="form-control" name="cancellation_hr" onChange={this.handleInputChange} value={this.state.cancellation_hr}/>
						<div className="errorsettings_cancellation_hr"></div>
					</div>
					<div className="form-group">					
					 <label>Appointment Duration<span class="required" style={{ color: "red" }} > </span></label>
						<Select 
							  options={lang.common.appointment_duration}  
							   value={selectedapptduration?selectedapptduration:{ value: '0', label: 'Select appointment duration' }}
							   onChange={this.handleChangeapptduration}
						/>		
					</div>
				
				</div>

				<div className="form-right">
					<div className="form-group">
						<label>Reschedule fees type: </label>
						<br></br>
						<input onChange={this.handleInputChange} type="radio" name="reschedule_fees_type" checked={this.state.reschedule_fees_type=='flat'?'chekced':''} value="flat"/>
						<span>Flat Amount</span>
							<input onChange={this.handleInputChange} type="radio"  name="reschedule_fees_type" checked={this.state.reschedule_fees_type=='percentage'?'chekced':''} value="percentage" />
						<span>Percentage</span>
					</div> 
					<div className="form-group"> 
						<label className='reschedule_fee'>Reschedule fees<span class="required" style={{ color: "red" }} > * </span>
						:</label>
						<input type="text" className="form-control" name="reschedule_fee" onChange={this.handleInputChange} value={this.state.reschedule_fee}/>
						<div className="errorsettings_reschedule_fee"></div>
					</div>
					<div className="form-group"> 
						<label>Reschedule Hours<span class="required" style={{ color: "red" }} > * </span>
						:</label>
						<input type="text" className="form-control" name="reschedule_hr" onChange={this.handleInputChange} value={this.state.reschedule_hr}/>
						<div className="errorsettings_reschedule_hr"></div>
					</div>

					{/* <div className="form-group"> 
						<label>Mail Send Time<span class="required" style={{ color: "red" }} > * </span>
						:</label>
						<input type="text" className="form-control" name="mailsend_doctor_time" onChange={this.handleInputChange} value={this.state.mailsend_doctor_time}/>
						<div className="errorsettings_mailsend_doctor_time"></div>
					</div>	 */}

					{/* <div className="form-group"> 
						<label>Basic consultant fees($)<span class="required" style={{ color: "red" }} > * </span>
						:</label>
						<input type="text" className="form-control" name="basic_consultant_fee" onChange={this.handleInputChange} value={this.state.basic_consultant_fee}/>
						<div className="errorsettings_basic_consultant_fee"></div>
					</div> */}

				</div>
			</div>
				
			<div className="title">
				<h4>Video Consultation Settings</h4>
			</div>  
			<div className="form-row">

			

			<div className="form-left">
				<div className="form-group"> 
					<label className=''>Default Session Duration (in minutes) :</label>
					<input type="text" className="form-control" name="free_video_call_time" onChange={this.handleInputChange} value={this.state.free_video_call_time}/>
					<div className="errorsettings_reschedule_fee"></div>
				</div>
				<div className="form-group"> 
					<label>Additional session cost ($) :</label>
					<input type="text" className="form-control" name="videocall_additional_fee" onChange={this.handleInputChange} value={this.state.videocall_additional_fee}/>
					<div className="errorsettings_cancellation_hr"></div>
				</div>	
			</div>
			<div className="form-right">
				
				<div className="form-group"> 
					<label className=''>Additional session time (in minutes) : </label>
					<input type="text" className="form-control" name="extratime_videocall_fee" onChange={this.handleInputChange} value={this.state.extratime_videocall_fee}/>
					<div className="errorsettings_cancellation_fee"></div>
				</div>

				
				

			</div>
			</div>
			<div className="title">
				<h4>Commission Settings</h4>
			</div>  
			<div className="form-row">

			


				<div className="form-left">
					<div className="form-group">
						<label>Commission type: </label>
						<br></br>
						<input onChange={this.handleInputChange} type="radio" name="commission_type" checked={this.state.commission_type=='flat'?'chekced':''} value="flat"/>
						<span>Flat Amount </span>
							<input onChange={this.handleInputChange} type="radio"  name="commission_type" checked={this.state.commission_type=='percentage'?'chekced':''} value="percentage"/>
						<span>Percentage </span>
					</div> 

				
				</div>

				<div className="form-right">

				<div className="form-group"> 
						<label className='commission_amount'>Commission amount
							:</label>
						<input type="text" className="form-control" name="commission_amount" onChange={this.handleInputChange} value={this.state.commission_amount}/>
						<div className="errorsettings_commission_amount"></div>
					</div>
				</div>
			</div>

		   <div className="title">
				<h4>Stripe Configuration</h4>
		   </div> 
		   <div className="form-group">
				    <input onChange={this.handleInputChange} type="radio" name="settings_enable_live" checked={this.state.stripe_live_checked}/>
	                <span>Live</span>
	                 <input onChange={this.handleInputChange} type="radio"  name="settings_enable_sandbox" checked={this.state.stripe_sandbox_checked}/>
	                <span>SandBox</span>
            </div> 
			<div className="form-row">
			<div className="form-left">
			<div className="form-group">
					<label>Public Key<span class="required" style={{ color: "red" }} >* </span></label>
					<input type="text" className="form-control" name="settings_public_key" onChange={this.handleInputChange}  value={this.state.settings_public_key}/>
					<div className="errorsettings_public_key"></div>
				</div>

				<div className="form-group">
					<label>Product Key</label>
					<input type="text" className="form-control" name="settings_product_key" onChange={this.handleInputChange}  value={this.state.settings_product_key}/>
					<div className="errorsettings_product_key"></div>
					<span>Note : For Recurring payment(Monthly) the product key use.</span>
				</div>
					
			</div>	
			<div className="form-right">
				
			<div className="form-group">					
					<label>Secret Key<span class="required" style={{ color: "red" }} >* </span></label>
					<input type="password" className="form-control" name="settings_secret_key"  onChange={this.handleInputChange}  value={this.state.settings_secret_key} />
					<div className="errorsettings_secret_key"></div>
				</div>		
			</div>	
      	</div>	
							<div className="title">
				<h5>AI Sidebar Management</h5> 
		  	 	</div>
			 
			<div className="form-row">			
				<div className="form-left">	
					<div className="form-group">
						<label>Collapsed width:</label>
						<input type="number" className="form-control" name="st_aisidebar_collapsed_width"  onChange={this.handleInputChange} value={this.state.st_aisidebar_collapsed_width}/>
						<div className="errorsettings_st_position_top"></div>
					</div>
					<div className="form-group">
						<label>AI Main Sidebar width:</label>
						<input type="number" className="form-control" name="st_aisidebar_main_width"  onChange={this.handleInputChange} value={this.state.st_aisidebar_main_width}/>
						<div className="errorsettings_st_position_bottom"></div>
					</div>
				</div>
				<div className="form-right">
					<div className="form-group ">
						<label>Sidebar Icon width: </label>
						<input type="number" className="form-control" name="st_aisidebar_icon_width"  onChange={this.handleInputChange} value={this.state.st_aisidebar_icon_width}/>
						<div className="errorst_st_plugin_height"></div>
					</div>
					
					
				</div>
			</div>
			<div className="title">
				<h4>Radius Management</h4>
			</div> 

			<div className="form-row">

				<div className="form-right">	
			 		<div className="form-group">
						<label>Dropdown Menu Radius <span class="required" style={{ color: "red" }} > * </span></label>
						<input type="number" className="form-control" name="DropdownRadius" onChange={this.handleInputChange}  value={this.state.DropdownRadius}  />
						<div className="errorDropdownRadius"></div>
					</div>
					<div className="form-group">
						<label>Plugin Map Radius <span class="required" style={{ color: "red" }} > * </span></label>
						<input type="number" className="form-control" name="pluginMapRadius" onChange={this.handleInputChange}  value={this.state.pluginMapRadius}  />
						<div className="errorpluginMapRadius"></div>
					</div>
				</div><div className="form-left">	
			 		<div className="form-group">
						<label>Plugin Radius <span class="required" style={{ color: "red" }} > * </span></label>
						<input type="number" className="form-control" name="pluginRadius" onChange={this.handleInputChange}  value={this.state.pluginRadius}   />
						<div className="errorpluginRadius"></div>
					</div>
				</div>

			</div>
		 	<div className="title">
				<h4>Shadow Management</h4>
			</div> 
			<div className="form-row">
					{Object.entries(this.state.shadows).map(([key, value]) => (
						<div className="form-left" key={key}>
						<div className="form-group admin-panel-btn">
							<label>{this.labelFor(key)}:</label>
							<input
								value={value}
								type="text"
								autoComplete="off"
								className="form-control"
								style={{ width: "85%" }}
								onChange={(e) => this.handleInputChangeShadows(key, e.target.value)}
							/>
							<button
								type="button"
								onClick={() => this.confirmPopup(key)}
								style={{
									color: "white",
									padding: "14px",
									minWidth: "47px",
									height: "48px",
									backgroundColor: "rgb(5, 31, 58)",
									borderRadius: "0px 5px 5px 0px"
								}}
							>
							<i><svg xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i>
							</button>
						</div>
						</div>
					))}
			</div>
			<div className="form-row">	
				
					<div className="input-popup-action">
								<a className="popup-close position-absolute cursor-pointer" onClick={this.handleCancel}>
								X
								</a>
								<div className="title">
									<h4 style={{ fontSize: "30px" }}>
									{this.labelFor(this.state.activeShadowType)}
									</h4>
								</div>

									<div className="shadow-picker-container d-flex w-100 justify-content-between">
										<ShadowPicker
										value={this.state.shadows[this.state.activeShadowType] || ''}
										onChange={(value) => this.handleShadowChange(value)}
										className="shadow-picker"
										/>

										<div className="shadow-box" style={{ boxShadow: this.state.shadows[this.state.activeShadowType] || 'none' }}></div>
									</div>
									<div className="d-flex w-100 justify-content-end gap-2 mt-5">
										<a className="btn" onClick={this.handleSubmit}>
										Save
										</a>										
									</div>
					</div>
			</div>
			
		  <div className="title">
				<h4>Font Management</h4>
			</div> 
			<div className="form-row">		
				<div className="form-left">
					<div className="default-font">
							<div className="form-group">
								<label>Line Height</label>
								<input type="text" className="form-control" name="lineHeight" onChange={this.handleInputChange}  value={this.state.lineHeight}/>
								<div className="errorlineHeight"></div>
							</div>
						
					</div> 
				
				</div>
			</div>	
			{this.addMoreFunc()}	
			 <div className="btn-group export">	
				
                <button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true &&
                                <span className="load-data">Loading</span> 
                                } Submit
			    </button>	
			</div>

			</div>
			</form>
			</div>	
		</div>	
	</div>
		 	
    </div>
    );
  }
}

export default Setting;